(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33465,65622,21572],{

/***/ 7967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/topics",
      function () {
        return __webpack_require__(68679);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PIP_ERROR_CODE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73060);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85780);






var PIP_ERROR_CODE = "E5222";
var usePartPaymentStatus = function(goalUID) {
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID && isLoggedIn ? "v1/subscriptions/pay_in_parts_subscription_details?goal_uid=".concat(goalUID) : null), data = _ref.data, error = _ref.isError, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, [
        "data",
        "isError"
    ]);
    var partPaymentStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (data) return data;
        if ((error === null || error === void 0 ? void 0 : error.error_code) === PIP_ERROR_CODE) return error;
        return null;
    }, [
        data,
        error
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        partPaymentStatus: partPaymentStatus
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePartPaymentStatus);


/***/ }),

/***/ 55161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21322);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87312);






var keyFrameOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{max-height:0px;}50%{max-height:", height || "276px", ";padding-bottom:20px;}100%{padding-bottom:0px;}", "keyFrameOpen");
};
var keyFrameClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{padding-bottom:20px;max-height:", height || "276px", ";}100%{padding-bottom:0px;max-height:0px;}", "keyFrameClose");
};
var animationOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameOpen(height), " 300ms ease-in 0s", "animationOpen");
};
var animationClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameClose(height), " 300ms ease-out 0s", "animationClose");
};
var StyledMenu = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "elxihdt0",
    label: "StyledMenu"
})("&.MuiPopover-root .MuiPaper-root{width:", function(param) {
    var width = param.width;
    return width;
}, ";border:", function(param) {
    var $noBorder = param.$noBorder;
    return $noBorder ? "none" : "1px solid var(--color-shadow)";
}, ";border-radius:8px;margin-top:10px;background-color:var(--color-base-1);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), ";transform:none !important;opacity:1 !important;animation:", function(param) {
    var open = param.open, height = param.height;
    return open ? animationOpen(height) : animationClose(height);
}, ";max-height:", function(param) {
    var height = param.height;
    return height;
}, ";-ms-overflow-style:none;/* Internet Explorer 10+ */\n    scrollbar-width:none;/* Firefox */\n    /* Chrome and IOS Safari */::-webkit-scrollbar{width:0px;background:transparent;}}&.MuiPopover-root .MuiMenu-list{padding-top:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";padding-bottom:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";}");
var Menu = function(param) {
    var children = param.children, anchorEl = param.anchorEl, onClose = param.onClose, position = param.position, width = param.width, height = param.height, noPadding = param.noPadding, noBorder = param.noBorder, anchorOrigin = param.anchorOrigin, transformOrigin = param.transformOrigin, className = param.className, disablePortal = param.disablePortal;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledMenu, {
        className: className,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: onClose,
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: anchorOrigin || {
            vertical: "bottom",
            horizontal: position
        },
        transformOrigin: transformOrigin || {
            vertical: "top",
            horizontal: position
        },
        variant: "menu",
        transitionDuration: 200,
        width: width,
        height: height,
        $noPadding: noPadding,
        $noBorder: noBorder,
        disablePortal: disablePortal,
        children: children
    });
};
Menu.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
    anchorOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    transformOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    position: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "left",
        "center",
        "right"
    ]),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    noPadding: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    noBorder: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        null,
        (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
    ]),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
Menu.defaultProps = {
    anchorOrigin: null,
    transformOrigin: null,
    position: "left",
    width: "auto",
    height: "276px",
    noPadding: false,
    noBorder: false,
    anchorEl: null,
    className: "",
    disablePortal: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55161);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21572);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98811);

/* eslint-disable react/display-name */ /* eslint-disable react/prop-types */ 









var DropDownButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("button", {
    target: "e1v4hctf0",
    label: "DropDownButton"
})("display:flex;justify-content:space-between;min-width:fit-content;align-self:center;align-items:center;line-height:150%;cursor:", function(param) {
    var $isDisabled = param.$isDisabled;
    return $isDisabled ? "not-allowed" : "pointer";
}, ";transition:all 400ms ease-in-out;border-width:1px;border-style:solid;font-weight:600;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";background-color:var(--color-base-1);grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_4B */ .t8.BM, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Fonts.SMALL */ .F3.HC, ";color:var(--color-text-primary);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder, open = param.open;
    if (showSelectedBorder) return "var(--color-text-primary)";
    if (open) return "var(--color-divider)";
    return "var(--color-shadow)";
}, ";", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth && "width: ".concat(buttonWidth, ";");
}, ":hover{background-color:var(--color-base-1);border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder;
    return showSelectedBorder ? "var(--color-text-primary)" : "var(--color-divider)";
}, ";box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw,
    blur: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw
}), ";}@media (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){font-size:12px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, ";white-space:nowrap;grid-column:", function(param) {
    var mwGridColumn = param.mwGridColumn;
    return mwGridColumn || "auto";
}, " !important;}");
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(param, ref) {
    var open = param.open, onClick = param.onClick, gridColumn = param.gridColumn, mwGridColumn = param.mwGridColumn, children = param.children, showSelectedBorder = param.showSelectedBorder, className = param.className, buttonWidth = param.buttonWidth, $isDisabled = param.$isDisabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DropDownButton, {
        open: open,
        onClick: onClick,
        gridColumn: gridColumn,
        mwGridColumn: mwGridColumn,
        ref: ref,
        showSelectedBorder: showSelectedBorder,
        className: className,
        type: "button",
        buttonWidth: buttonWidth,
        $isDisabled: $isDisabled,
        children: children
    });
});
var StyledArrowDown = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__["default"], {
    target: "e1v4hctf1",
    label: "StyledArrowDown"
})("transition:transform 400ms ease-in-out;transform:", function(param) {
    var open = param.open;
    return open ? "rotate(180deg)" : "rotate(0deg)";
}, ";@media only screen and (max-width:47.95em){margin-left:8px;}");
var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1v4hctf2",
    label: "IconWrapper"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:flex;");
var getFavoriteKey = function(option) {
    return [
        "value",
        "code",
        "id",
        "uid"
    ].find(function(key) {
        return Object.keys(option || {}).some(function(k) {
            return k === key;
        });
    });
};
var selectedOptionHasValueOrId = function(selectedOption) {
    var favoriteKey = getFavoriteKey(selectedOption);
    return !lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default()(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]);
};
var isDefined = function(value) {
    return !(value === undefined || value === null);
};
var isSelected = function(selectedOption, option) {
    var favoriteKey = getFavoriteKey(selectedOption);
    if (isDefined(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) === (option === null || option === void 0 ? void 0 : option[favoriteKey])) return true;
    return false;
};
var Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    var _options = props.options, options = _options === void 0 ? [] : _options, selectedOption = props.selectedOption, onOptionClick = props.onOptionClick, onClick = props.onClick, displayCheck = props.displayCheck, children = props.children, gridColumn = props.gridColumn, mwGridColumn = props.mwGridColumn, links = props.links, isDisabled = props.isDisabled, stripLength = props.stripLength, showSelectedBorder = props.showSelectedBorder, className = props.className, openDropDown = props.openDropDown, closeDropdown = props.closeDropdown, state = props.state, useOuterState = props.useOuterState, displayIcon = props.displayIcon, menuWidth = props.menuWidth, menuHeight = props.menuHeight, buttonWidth = props.buttonWidth, placeholder = props.placeholder, menuColor = props.menuColor, topChildren = props.topChildren, showIcon = props.showIcon, textColor = props.textColor, getKey = props.getKey, disablePortal = props.disablePortal;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), anchorEl = _$ref[0], setAnchorEl = _$ref[1];
    var handleClick = function(event) {
        onClick();
        if (isDisabled) {
            return;
        }
        if (useOuterState) openDropDown(event.currentTarget);
        else setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        if (useOuterState) closeDropdown();
        else setAnchorEl(null);
    };
    var handleOptionClick = function(option) {
        onOptionClick(option);
        handleClose();
    };
    var stripLabel = function(label) {
        if (stripLength && (label === null || label === void 0 ? void 0 : label.length) > stripLength) return "".concat(label.substr(0, stripLength), " ...");
        return label;
    };
    var stateOrAnchor = state || anchorEl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Button, {
                open: stateOrAnchor,
                onClick: handleClick,
                gridColumn: gridColumn,
                mwGridColumn: mwGridColumn,
                ref: ref,
                showSelectedBorder: showSelectedBorder && selectedOptionHasValueOrId(selectedOption),
                className: className,
                buttonWidth: buttonWidth,
                $isDisabled: isDisabled,
                children: [
                    displayIcon ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                        className: "iconWrapper",
                        children: displayIcon
                    }) : null,
                    selectedOption ? stripLabel(selectedOption.label || selectedOption.name || selectedOption.display_name || "No preference") : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: textColor || "var(--color-text-secondary)",
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledArrowDown, {
                        open: stateOrAnchor,
                        size: "16px",
                        color: "var(--color-text-primary)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                anchorEl: stateOrAnchor,
                onClose: handleClose,
                width: menuWidth,
                height: menuHeight,
                disablePortal: disablePortal,
                children: [
                    topChildren,
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            displayCheck: displayCheck,
                            selected: isSelected(selectedOption, option),
                            option: option,
                            onClick: handleOptionClick,
                            links: links,
                            color: menuColor,
                            showIcon: showIcon
                        }, getKey(option) || index);
                    }),
                    children
                ]
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.propTypes = {
    selectedOption: prop_types__WEBPACK_IMPORTED_MODULE_10___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    options: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    onOptionClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    displayCheck: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    mwGridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    links: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    stripLength: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    showSelectedBorder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    displayIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    menuWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    menuHeight: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    buttonWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    showIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    getKey: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool)
};
Dropdown.defaultProps = {
    selectedOption: null,
    options: [],
    displayCheck: false,
    showIcon: false,
    children: null,
    gridColumn: "span 4",
    mwGridColumn: "auto",
    links: false,
    stripLength: null,
    showSelectedBorder: true,
    displayIcon: null,
    menuWidth: "233px",
    menuHeight: "276px",
    buttonWidth: null,
    onClick: function() {},
    placeholder: "",
    getKey: function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.id);
    },
    disablePortal: false
};


/***/ }),

/***/ 98811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76356);
/* harmony import */ var _icon_Check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92542);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);






var StyledItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx60",
    label: "StyledItem"
})("display:flex;align-items:center;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_3B */ .t8.N, ";cursor:pointer;");
var LinkedLi = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx61",
    label: "LinkedLi"
})("cursor:pointer;");
var GoalImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("img", {
    target: "e10ouzx62",
    label: "GoalImage"
})("height:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("span", {
    target: "e10ouzx63",
    label: "Label"
})("font-size:14px;line-height:150%;color:", function(param) {
    var selected = param.selected;
    return selected ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";color:", function(param) {
    var color = param.color, selected = param.selected;
    return selected && color;
}, ";flex-grow:1;display:block;font-weight:", function(param) {
    var selected = param.selected;
    return selected ? "bold" : "initial";
}, ";");
var anchorStyle = "display: flex; align-items: center; padding: 8px 16px;";
var item = function(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon) {
    var _$ref = option || {}, selGoalIcon = _$ref.icon, selGoalName = _$ref.name, as = _$ref.as, href = _$ref.href, label = _$ref.label, name = _$ref.name, display_name = _$ref.display_name;
    var goalImage = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GoalImage, {
        src: selGoalIcon,
        alt: selGoalName
    });
    if (links) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkedLi, {
        onClick: onMenuClick,
        ref: ref,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            anchorStyle: anchorStyle,
            as: as,
            href: href,
            children: [
                showIcon && goalImage,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                    selected: selected,
                    color: color,
                    children: option.label || option.name || option.display_name
                }),
                selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: "24px",
                    color: "var(--color-i-green)"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledItem, {
        ref: ref,
        onClick: onMenuClick,
        children: [
            showIcon && goalImage,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                selected: selected,
                color: color,
                children: label || name || display_name || "No preference"
            }),
            selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: "24px",
                color: "var(--color-i-green)"
            })
        ]
    });
};
var MenuItem = function(param, ref) {
    var option = param.option, selected = param.selected, onClick = param.onClick, displayCheck = param.displayCheck, links = param.links, color = param.color, showIcon = param.showIcon;
    var onMenuClick = function() {
        return onClick(option);
    };
    return item(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(MenuItem));


/***/ }),

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _base_H5_H5__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43807);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80867);
/* harmony import */ var _base_P2_P2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72560);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);






var ContentWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])("div", {
    target: "ee8j8kx0",
    label: "ContentWrapper"
})("height:100vh;margin:auto;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0 ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_10B */ .t8.FC, ";");
var ImageWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])("div", {
    target: "ee8j8kx1",
    label: "ImageWrapper"
})("position:relative;height:80px;width:80px;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_3B */ .t8.N, ";");
var StyledH5 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])(_base_H5_H5__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    target: "ee8j8kx2",
    label: "StyledH5"
})("width:90%;font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Fonts.SEMIBOLD */ .F3.rX, ";text-align:center;");
var StyledP2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])(_base_P2_P2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ee8j8kx3",
    label: "StyledP2"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_1B */ .t8.MK, ";text-align:center;");
var GTPMobileBlocker = function(param) {
    var goalInfo = param.goalInfo;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(ContentWrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ImageWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    src: "/gtp/gtp-mobile-icon.svg",
                    alt: "educator",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledH5, {
                children: [
                    "Access ",
                    goalInfo.name,
                    " from your desktop"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledP2, {
                color: "var(--color-text-secondary)",
                children: "We\u2019re bringing this goal to the app soon. You can access it from desktop till then."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GTPMobileBlocker);


/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ greetingTopSpacing; },
/* harmony export */   "Cj": function() { return /* binding */ eventPadding; },
/* harmony export */   "Du": function() { return /* binding */ timelineTopSpacing; },
/* harmony export */   "EV": function() { return /* binding */ GTP_SUBSCRIPTION; },
/* harmony export */   "UA": function() { return /* binding */ PLATFORM_SUBSCRIPTION; },
/* harmony export */   "UI": function() { return /* binding */ plannerItemTypeHeightMap; },
/* harmony export */   "ZL": function() { return /* binding */ dayTitleLeftSpacing; },
/* harmony export */   "cX": function() { return /* binding */ browseTopSpacing; },
/* harmony export */   "eg": function() { return /* binding */ PLUS_SUBSCRIPTION; },
/* harmony export */   "et": function() { return /* binding */ plannerItemTypes; },
/* harmony export */   "iH": function() { return /* binding */ eventHeightMap; },
/* harmony export */   "jb": function() { return /* binding */ classCardHeight; },
/* harmony export */   "z1": function() { return /* binding */ eventTopSpacing; }
/* harmony export */ });
/* unused harmony export daySpacing */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _constants_schedule__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88268);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var plannerItemTypes = {
    EVENT: "event",
    TIMELINE: "timeline",
    DAY_TITLE: "day_title",
    GREETING: "greeting",
    SUBSCRIPTION_FEEDBACK: "subscription_feedback",
    SUBSCRIPTION_RENEWAL: "renewal_card",
    FEATURE_CARD: "feature_card",
    FEATURE_INTRODUCTION: "feature_introduction",
    FEATURE_AWARENESS: "feature_card",
    BROWSE: "browse",
    SUBSCRIPTION_FEEDBACK_V2: "subscription_feedback_v2",
    FREE_TRIAL_CARD: "trial_subscription",
    SKELETON_LOADER: "skeleton_loader"
};
var daySpacing = 20;
var timelineTopSpacing = 24;
var eventTopSpacing = 24;
var browseTopSpacing = 24;
var greetingTopSpacing = 20;
var classCardHeight = 162;
var dayTitleLeftSpacing = _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_7B */ .t8.d5;
var _obj;
var plannerItemTypeHeightMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.DAY_TITLE, 64), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.TIMELINE, 12 + timelineTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.BROWSE, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.GREETING, 72 + greetingTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_RENEWAL, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_INTRODUCTION, 168 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_AWARENESS, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SKELETON_LOADER, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FREE_TRIAL_CARD, 212 + browseTopSpacing), _obj);
var _obj1;
var eventHeightMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS */ .pt.CLASS, classCardHeight + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS_WITH_PRACTICE */ .pt.CLASS_WITH_PRACTICE, 222 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST */ .pt.TEST, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST_WITH_EDUCATOR */ .pt.TEST_WITH_EDUCATOR, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.QUIZ */ .pt.QUIZ, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.COMBAT */ .pt.COMBAT, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.LIVE_INTERACTION */ .pt.LIVE_INTERACTION, 98 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.DAILY_PRACTICE_REMINDER */ .pt.DAILY_PRACTICE_REMINDER, 84 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OPENHOUSE */ .pt.OPENHOUSE, 80 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OFFLINE_TEST */ .pt.OFFLINE_TEST, 136 + eventTopSpacing), _obj1);
var eventPadding = 16;
var PLUS_SUBSCRIPTION = "plus_subscription";
var PLATFORM_SUBSCRIPTION = "platform_subscription";
var GTP_SUBSCRIPTION = "gtp_subscription";


/***/ }),

/***/ 28665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlusTopics_PlusTopology; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/components/Base/BreadCrumbs/BreadCrumbs.jsx
var BreadCrumbs = __webpack_require__(17562);
// EXTERNAL MODULE: ./src/components/Base/H2/H2.jsx
var H2 = __webpack_require__(39396);
// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./src/hooks/useSubscribed.js
var useSubscribed = __webpack_require__(83497);
// EXTERNAL MODULE: ./src/hooks/useFirstRenderSkip.js
var useFirstRenderSkip = __webpack_require__(6858);
// EXTERNAL MODULE: ./src/utils/breadcrumbs.js
var breadcrumbs = __webpack_require__(23018);
// EXTERNAL MODULE: ./src/redux/actions/topologies.js
var topologies = __webpack_require__(62282);
// EXTERNAL MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx + 1 modules
var InfiniteList = __webpack_require__(88074);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/redux/selectors/auth.js
var auth = __webpack_require__(34497);
// EXTERNAL MODULE: ./src/redux/selectors/syllabus.js + 1 modules
var syllabus = __webpack_require__(10448);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var subscription = __webpack_require__(83553);
// EXTERNAL MODULE: ./src/layout/NavBar/PlusNavBar/plusNavBarItems.js
var plusNavBarItems = __webpack_require__(2990);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/components/Container/PlusTopics/PreSubscriptionBanner.jsx + 2 modules
var PreSubscriptionBanner = __webpack_require__(69737);
;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/PreSubscriptionContent.jsx







var imageProps = {
    src: (0,imageHelper/* getImage */.gJ)("pre_subscription_courses.svg"),
    size: styleConstants/* Spacings.SPACING_12B */.t8.SL
};
var PreSubscriptionContent = function(param) {
    var source = param.source, topology = param.topology, headerTitle = param.headerTitle, goalUID = param.goalUID;
    var preSubscriptionBannerTitle = "";
    var preSubscriptionBannerContent = "";
    if (source === constants/* PlusTopologySource.TOPICS */.e.TOPICS) {
        preSubscriptionBannerTitle = topology.coursesCount > 0 ? "Access more than" : "";
        if (topology.coursesCount === 0) {
            preSubscriptionBannerContent = "New courses coming soon";
        } else if (topology.coursesCount === 1) {
            preSubscriptionBannerContent = "1 course for ".concat(topology.name);
        } else {
            preSubscriptionBannerContent = "".concat((0,textHelper/* commas */.q1)(topology.coursesCount), "+ courses for ").concat(topology.name);
        }
    } else {
        preSubscriptionBannerTitle = "In ".concat(headerTitle);
        if (topology.upcomingCoursesThisMonth === 0) {
            preSubscriptionBannerContent = "New courses coming soon";
        } else if (topology.upcomingCoursesThisMonth === 1) {
            preSubscriptionBannerContent = "1 course starting this month";
        } else {
            preSubscriptionBannerContent = "".concat((0,textHelper/* commas */.q1)(topology.upcomingCoursesThisMonth), "+ courses starting this month");
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreSubscriptionBanner/* default */.Z, {
        imageProps: imageProps,
        title: preSubscriptionBannerTitle,
        content: preSubscriptionBannerContent,
        goalUID: goalUID
    });
};
PreSubscriptionContent.propTypes = {
    source: (prop_types_default()).string.isRequired,
    topology: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    headerTitle: (prop_types_default()).string.isRequired,
    goalUID: (prop_types_default()).string.isRequired
};
/* harmony default export */ var PlusTopics_PreSubscriptionContent = (PreSubscriptionContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Container/FeedTypeBlock/FeedTypeBlock.jsx + 5 modules
var FeedTypeBlock = __webpack_require__(16915);
// EXTERNAL MODULE: ./src/utils/feedTypeHelper.js
var feedTypeHelper = __webpack_require__(99682);
// EXTERNAL MODULE: ./src/redux/selectors/topologies.js
var selectors_topologies = __webpack_require__(83109);
// EXTERNAL MODULE: ./src/models/Topology.js
var Topology = __webpack_require__(34482);
;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/TopicCardComponents/topicCardUtils.js
var windowMap = {
    TODAY: 0,
    TOMORROW: 1,
    THIS_WEEK: 2,
    IN_15_DAYS: 3,
    YESTERDAY: -1,
    LAST_WEEK: -2,
    AGO_15_DAYS: -3
};
var hasWindowInfoText = function(topic) {
    return (topic.window === windowMap.TODAY || topic.window === windowMap.TOMORROW) && topic.windowCount > 0;
};

;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/TopicCardElements.jsx


var UpcomingCourses = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "esfpy360",
    label: "UpcomingCourses"
})("color:var(--color-i-red);font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";");
var EnrolledCourses = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "esfpy361",
    label: "EnrolledCourses"
})("color:var(--color-i-green);font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";");
var CoursesInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "esfpy362",
    label: "CoursesInfo"
})("color:var(--color-text-secondary);display:flex;align-items:center;");

;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/TopicGroupCardInfoText.jsx






var TopicGroupCardInfoText = function(param) {
    var topic = param.topic, topologyCoursesCount = param.topologyCoursesCount, isSubscribed = param.isSubscribed;
    var upcomingCoursesCount = topic.upcomingCoursesCount, enrolledCoursesCount = topic.enrolledCoursesCount;
    var renderPrimaryCoursesCount = null;
    var renderSecondaryCoursesCount = "";
    var topologyCourses = topologyCoursesCount > 0 ? (0,textHelper/* pluralize */._6)(topologyCoursesCount, "course") : "";
    if (!isSubscribed) {
        if (upcomingCoursesCount > 0) {
            renderPrimaryCoursesCount = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpcomingCourses, {
                children: "".concat(upcomingCoursesCount, " upcoming")
            });
            renderSecondaryCoursesCount = "".concat(styleConstants/* Spacings.SPACING_1SPACE */.t8.Wg, "\u2022 ");
        }
        renderSecondaryCoursesCount += topologyCourses;
    } else {
        if (enrolledCoursesCount > 0) {
            renderPrimaryCoursesCount = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnrolledCourses, {
                children: "".concat(enrolledCoursesCount, " enrolled")
            });
        } else if (topologyCoursesCount > 0) {
            renderPrimaryCoursesCount = topologyCourses;
        } else {
            renderPrimaryCoursesCount = "Courses will be added soon";
        }
        if (upcomingCoursesCount > 0) {
            renderSecondaryCoursesCount = "".concat(styleConstants/* Spacings.SPACING_1SPACE */.t8.Wg, "\u2022 ").concat(upcomingCoursesCount, " upcoming");
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CoursesInfo, {
        children: [
            renderPrimaryCoursesCount,
            renderSecondaryCoursesCount
        ]
    });
};
TopicGroupCardInfoText.propTypes = {
    topic: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    topologyCoursesCount: (prop_types_default()).number.isRequired,
    isSubscribed: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var PlusTopics_TopicGroupCardInfoText = (TopicGroupCardInfoText);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/TopicCardComponents/TopicCardInfoText.jsx









var WindowImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "eb0mq360",
    label: "WindowImage"
})("margin-right:", styleConstants/* Spacings.SPACING_6 */.t8.A1, ";flex:0 0 auto;");
var _obj;
var windowLabelMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, windowMap.TODAY, "today"), (0,_define_property/* default */.Z)(_obj, windowMap.TOMORROW, "tomorrow"), (0,_define_property/* default */.Z)(_obj, windowMap.THIS_WEEK, "this week"), (0,_define_property/* default */.Z)(_obj, windowMap.IN_15_DAYS, "in 15 days"), (0,_define_property/* default */.Z)(_obj, windowMap.YESTERDAY, "yesterday"), (0,_define_property/* default */.Z)(_obj, windowMap.LAST_WEEK, "last week"), (0,_define_property/* default */.Z)(_obj, windowMap.AGO_15_DAYS, "15 days ago"), _obj);
var TopicCardInfoText = function(param) {
    var topic = param.topic, isSubscribed = param.isSubscribed;
    var upcomingCoursesCount = topic.upcomingCoursesCount, enrolledCoursesCount = topic.enrolledCoursesCount;
    var renderPrimaryCoursesCount = null;
    var renderSecondaryCoursesCount = "";
    if (!isSubscribed) {
        if (hasWindowInfoText(topic)) {
            renderPrimaryCoursesCount = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WindowImage, {
                        src: (0,imageHelper/* getImage */.gJ)("window_courses.svg"),
                        size: "14px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpcomingCourses, {
                        children: "".concat((0,textHelper/* pluralize */._6)(topic.windowCount, "course"), " starting ").concat(windowLabelMap[topic.window])
                    })
                ]
            });
        }
    } else if (enrolledCoursesCount > 0) {
        renderPrimaryCoursesCount = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnrolledCourses, {
            children: "".concat(enrolledCoursesCount, " enrolled")
        });
    } else if (upcomingCoursesCount > 0) {
        renderPrimaryCoursesCount = "".concat(upcomingCoursesCount, " upcoming");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CoursesInfo, {
        children: [
            renderPrimaryCoursesCount,
            renderSecondaryCoursesCount
        ]
    });
};
TopicCardInfoText.propTypes = {
    topic: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    isSubscribed: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var TopicCardComponents_TopicCardInfoText = (TopicCardInfoText);

// EXTERNAL MODULE: ./src/components/Icons/CheckCircleFilled.jsx
var CheckCircleFilled = __webpack_require__(29558);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
;// CONCATENATED MODULE: ./src/components/Base/CircularProgress/UnfilledCircle.jsx



var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ec65oah0",
    label: "Wrapper"
})("position:absolute;width:", function(param) {
    var $size = param.$size;
    return "".concat($size, "px");
}, ";height:", function(param) {
    var $size = param.$size;
    return "".concat($size, "px");
}, ";top:0;left:0;bottom:0;right:0;");
var UnfilledCircle = function(param) {
    var circleDiameter = param.circleDiameter, className = param.className, color = param.color, thickness = param.thickness, size = param.size;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        $size: size,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
            viewBox: "".concat(circleDiameter / 2, " ").concat(circleDiameter / 2, " ").concat(circleDiameter, " ").concat(circleDiameter),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                className: className,
                cx: circleDiameter,
                cy: circleDiameter,
                r: (circleDiameter - thickness) / 2,
                fill: "none",
                strokeWidth: thickness,
                stroke: color
            })
        })
    });
};
UnfilledCircle.propTypes = {
    circleDiameter: (prop_types_default()).number,
    className: (prop_types_default()).string,
    color: (prop_types_default()).string,
    thickness: (prop_types_default()).number,
    size: (prop_types_default()).number
};
UnfilledCircle.defaultProps = {
    circleDiameter: 44,
    className: "",
    color: "var(--color-i-blue)",
    thickness: 3.6,
    size: 40
};
/* harmony default export */ var CircularProgress_UnfilledCircle = (UnfilledCircle);

;// CONCATENATED MODULE: ./src/components/Base/CircularProgress/CircularProgress.jsx





var StyledCircularProgress = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CircularProgress/* default */.Z, {
    target: "e1b58fta0",
    label: "StyledCircularProgress"
})("color:", function(param) {
    var $customColor = param.$customColor;
    return $customColor;
}, ";");
var CircularProgress_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1b58fta1",
    label: "Wrapper"
})("position:relative;");
var SIZE = 44;
var CircularProgressBar = function(param) {
    var color = param.color, size = param.size, className = param.className, thickness = param.thickness, value = param.value, unfilledColor = param.unfilledColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CircularProgress_Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularProgress_UnfilledCircle, {
                circleDiameter: SIZE,
                color: unfilledColor,
                size: size,
                thickness: thickness
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCircularProgress, {
                $customColor: color,
                size: size,
                thickness: thickness,
                value: value,
                variant: "determinate"
            })
        ]
    });
};
CircularProgressBar.propTypes = {
    color: (prop_types_default()).string,
    size: (prop_types_default()).number,
    className: (prop_types_default()).string,
    thickness: (prop_types_default()).number,
    value: (prop_types_default()).number,
    unfilledColor: (prop_types_default()).string
};
CircularProgressBar.defaultProps = {
    color: "var(--color-i-green)",
    size: 40,
    className: "",
    thickness: 3.6,
    value: 0,
    unfilledColor: "var(--color-i-blue)"
};
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgressBar);

;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/TopicCardComponents/TopicProgress.jsx






var CourseProgress = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CircularProgress_CircularProgress, {
    target: "e1vc89310",
    label: "CourseProgress"
})("grid-row:span 2;align-self:center;margin-right:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";");
var CheckboxFilled = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CheckCircleFilled/* default */.Z, {
    target: "e1vc89311",
    label: "CheckboxFilled"
})("grid-row:span 2;align-self:center;");
var TopicProgress = function(param) {
    var topic = param.topic;
    if (topic.progress > 0) {
        if (topic.progress === 100) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxFilled, {
                size: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                color: "var(--color-i-green)"
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseProgress, {
            size: 25,
            thickness: 5,
            value: topic.progress,
            unfilledColor: "var(--color-divider)"
        });
    }
    return null;
};
TopicProgress.propTypes = {
    topic: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var TopicCardComponents_TopicProgress = (TopicProgress);

;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/FeedBlockContainer.jsx


















var InfoTextContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1iqjm240",
    label: "InfoTextContainer"
})("height:18px;");
var getBlockInfo = function(param) {
    var goalTopology = param.goalTopology, entityType = param.entityType, feedType = param.feedType, feedUid = param.feedUid, isSyllabusPage = param.isSyllabusPage, topicHasInfo = param.topicHasInfo, topicPlusCoursesCount = param.topicPlusCoursesCount, goalUID = param.goalUID;
    var isClassFeed = (0,feedTypeHelper/* isClassFeed */.wN)(entityType);
    var blockInfo = {
        viewAllHref: "",
        viewAllLink: "",
        blockKey: "".concat(feedType, "-").concat(feedUid)
    };
    if (isSyllabusPage) {
        return (0,_object_spread/* default */.Z)({}, blockInfo, isClassFeed && {
            viewAllHref: (0,Topology/* getTopicLinkHref */.BR)(),
            viewAllLink: (0,Topology/* getTopicLink */.pA)({
                uid: feedUid
            }, goalTopology)
        });
    }
    var shouldShowSeeAllLink = isClassFeed && (!topicHasInfo || topicPlusCoursesCount > 3);
    return (0,_object_spread/* default */.Z)({}, blockInfo, shouldShowSeeAllLink && {
        viewAllHref: (0,Topology/* getCoursesHref */.TW)(),
        viewAllLink: (0,Topology/* getCoursesAsPath */.b4)(goalTopology.slug, goalUID, feedUid)
    });
};
var FeedBlockContainer = function(param) {
    var feed = param.item, goalUID = param.goalUID, source = param.source;
    var extraBlockInfo = feed.extraBlockinfo || {};
    var feedUid = extraBlockInfo.uid || "";
    var entityType = extraBlockInfo.entity_type;
    var goalTopology = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getTopologyInfo */.b)(state, goalUID);
    });
    var isSyllabusPage = source === constants/* PlusTopologySource.TOPICS */.e.TOPICS;
    // #region topic-page-data
    var topicHasInfo = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_topologies/* getHasTopologyInfo */.CD)(state, feedUid);
    });
    var topicPlusCoursesCount = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_topologies/* getTopologyPlusCoursesCount */.gc)(state, feedUid);
    });
    // #endregion
    var ref = getBlockInfo({
        goalTopology: goalTopology,
        entityType: entityType,
        feedType: feed.type,
        feedUid: feedUid,
        isSyllabusPage: isSyllabusPage,
        topicHasInfo: topicHasInfo,
        topicPlusCoursesCount: topicPlusCoursesCount,
        goalUID: goalUID
    }), viewAllHref = ref.viewAllHref, viewAllLink = ref.viewAllLink, blockKey = ref.blockKey;
    var isSubscribed = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToPlus */.FZ)(goalUID));
    var isOfflineSubscription = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    var feedProps = {
        topic: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isSyllabusPage ? {
            renderCourses: function topicGroupCardInfoText(topic, topologyCoursesCount) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoTextContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusTopics_TopicGroupCardInfoText, {
                        topic: topic,
                        topologyCoursesCount: topologyCoursesCount,
                        isSubscribed: isSubscribed || isOfflineSubscription
                    })
                });
            }
        } : {
            renderProgress: function renderProgressBar(topic) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicCardComponents_TopicProgress, {
                    topic: topic
                });
            },
            renderCourses: function topicCardInfoText(topic) {
                return isSubscribed || isOfflineSubscription || hasWindowInfoText(topic) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoTextContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicCardComponents_TopicCardInfoText, {
                        topic: topic,
                        isSubscribed: isSubscribed || isOfflineSubscription
                    })
                }) : null;
            }
        }), {
            hideIfNoCourses: true
        }),
        class: {
            topic: {
                uid: extraBlockInfo.uid,
                name: extraBlockInfo.title
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedTypeBlock/* default */.Z, {
        goalUID: goalUID,
        goalSlug: goalTopology.slug,
        feedBlock: feed,
        goal: goalTopology,
        type: "syllabus",
        viewAllLink: viewAllLink,
        viewAllHref: viewAllHref,
        feedProps: feedProps,
        dataAnalytics: "syllabus"
    }, blockKey);
};
FeedBlockContainer.propTypes = {
    item: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    goalUID: (prop_types_default()).string.isRequired,
    source: (prop_types_default()).string.isRequired
};
var MemoizedFeedBlockContainer = /*#__PURE__*/ react.memo(FeedBlockContainer);
/* harmony default export */ var PlusTopics_FeedBlockContainer = (MemoizedFeedBlockContainer);

;// CONCATENATED MODULE: ./src/components/Container/PlusTopics/PlusTopology.jsx






















var HeaderNavBar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "ertc74j0",
    label: "HeaderNavBar"
})("margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " ", styleConstants/* Spacings.SPACING_12B */.t8.SL, " ", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{background:var(--color-base-0);box-shadow:none;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " 0 0 0;margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H2/* default */.Z, {
    target: "ertc74j1",
    label: "Title"
})("margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";height:38px;font-size:", styleConstants/* Fonts.H2 */.F3.H2, ";");
var getFeedBlockKey = function(feed) {
    return feed.uid;
};
var PlusTopologyContent = function(param) {
    var source = param.source, topologyFeedUID = param.topologyFeedUID, itemExtraProps = param.itemExtraProps;
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var topologyFeed = (0,reduxHooks/* useSelectorToStore */.nZ)(function(state) {
        return (0,syllabus/* getTopologyFeed */.dM)(state, topologyFeedUID);
    });
    var loadMoreFeedBlocks = function() {
        return dispatch((0,topologies/* fetchTopologyFeed */.b1)({
            topologyUid: topologyFeedUID,
            pageSource: source,
            nextPage: true
        }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
        data: topologyFeed,
        loadMore: loadMoreFeedBlocks,
        RenderItem: PlusTopics_FeedBlockContainer,
        getItemKey: getFeedBlockKey,
        extraProps: itemExtraProps,
        gridColumn: "span 18"
    });
};
PlusTopologyContent.propTypes = {
    source: (prop_types_default()).string.isRequired,
    topologyFeedUID: (prop_types_default()).string.isRequired,
    itemExtraProps: prop_types_default().shape({
        goalUID: (prop_types_default()).string.isRequired,
        source: (prop_types_default()).string.isRequired
    }).isRequired
};
var getHeaderTitle = function(goalTopology, isSyllabusPage, topology) {
    var headerTitle = "".concat(goalTopology.name, " ").concat(plusNavBarItems/* default.PLAYLIST */.Z.PLAYLIST);
    if (goalTopology.isNoTestGoal) {
        headerTitle = "".concat(goalTopology.name, " Key concepts");
    }
    if (goalTopology.isRecordedGoal && isSyllabusPage) {
        return "Video lessons";
    }
    if (!isSyllabusPage) {
        headerTitle = "".concat(goalTopology.name, " ").concat(topology.name) || "";
    }
    return headerTitle;
};
var headerTags = function(goalTopology, source, isOfflineSubscription) {
    var tags = [];
    if (goalTopology) {
        var _tags;
        (_tags = tags).push.apply(_tags, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getPlusTopicsTags */.ZP.getPlusTopicsTags(goalTopology, isOfflineSubscription)));
        if (source === constants/* PlusTopologySource.TOPIC_FEED */.e.TOPIC_FEED) {
            var _tags1;
            (_tags1 = tags).push.apply(_tags1, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getTopics */.ZP.getTopics(goalTopology)));
        }
    }
    return tags;
};
var PlusTopology = function(param) {
    var source = param.source, goalUID = param.goalUID, topologyUID = param.topologyUID;
    var goalTopology = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getTopologyInfo */.b)(state, goalUID);
    });
    var topology = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getTopologyInfo */.b)(state, topologyUID);
    });
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var isSubscribed = (0,useSubscribed/* default */.Z)(goalUID);
    var isLiteUser = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToLite */.aA)(goalUID));
    var isLoggedIn = (0,es/* useSelector */.v9)(auth/* getIsLoggedIn */.M7);
    var isSyllabusPage = source === constants/* PlusTopologySource.TOPICS */.e.TOPICS;
    var isOfflineSubscription = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    // refresh feed after login
    (0,useFirstRenderSkip/* default */.Z)(function() {
        dispatch((0,topologies/* fetchTopologyFeed */.b1)({
            topologyUid: topology.uid,
            nextPage: true,
            pageSource: source,
            resetWithoutEmpty: true,
            params: {
                timestamp: Date.now()
            }
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    var headerTitle = getHeaderTitle(goalTopology, isSyllabusPage, topology);
    var renderPreSubscriptionContent = function() {
        if (isLiteUser) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusTopics_PreSubscriptionContent, {
            source: source,
            goalUID: goalUID,
            topology: topology,
            headerTitle: headerTitle
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderNavBar, {
                gridColumn: "span 18",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* default */.Z, {
                        tags: headerTags(goalTopology, source, isOfflineSubscription),
                        onBackClick: breadcrumbs/* goBack */.Hm,
                        useBackClick: true
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        lineClamp: 1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            title: headerTitle,
                            children: headerTitle
                        })
                    })
                ]
            }),
            !isSubscribed && renderPreSubscriptionContent(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusTopologyContent, {
                source: source,
                topologyFeedUID: topology.uid,
                itemExtraProps: {
                    goalUID: goalUID,
                    source: source
                }
            })
        ]
    });
};
var sources = Object.keys(constants/* PlusTopologySource */.e).map(function(key) {
    return constants/* PlusTopologySource */.e[key];
});
PlusTopology.propTypes = {
    source: prop_types_default().oneOf(sources).isRequired,
    goalUID: (prop_types_default()).string.isRequired,
    topologyUID: (prop_types_default()).string.isRequired
};
/* harmony default export */ var PlusTopics_PlusTopology = (PlusTopology);


/***/ }),

/***/ 88322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ DAILY_GOALS_OPTIONS; },
/* harmony export */   "Fj": function() { return /* binding */ DPP_SET_REMINDER_CLICKED; },
/* harmony export */   "G8": function() { return /* binding */ TOOLTIP_MAP; },
/* harmony export */   "Jb": function() { return /* binding */ DPP_COMPLETED; },
/* harmony export */   "Jf": function() { return /* binding */ QUERY_ACTIONS; },
/* harmony export */   "Kd": function() { return /* binding */ MAX_PRACTICE_SESSION_COUNT; },
/* harmony export */   "LJ": function() { return /* binding */ DISLIKE_REASONS; },
/* harmony export */   "Lr": function() { return /* binding */ MIN_QUESTIONS; },
/* harmony export */   "MA": function() { return /* binding */ FEEDBACK_OPTIONS_MAPPING; },
/* harmony export */   "Ny": function() { return /* binding */ MODAL_TYPES; },
/* harmony export */   "R1": function() { return /* binding */ DPP_SET_REMINDER_CARD_VIEWED; },
/* harmony export */   "Sx": function() { return /* binding */ YEAR_FILTER_TYPE; },
/* harmony export */   "Up": function() { return /* binding */ noPrefrenceCode; },
/* harmony export */   "VL": function() { return /* binding */ REVIEW_TYPE; },
/* harmony export */   "Ws": function() { return /* binding */ PRACTICE_TYPE; },
/* harmony export */   "Xg": function() { return /* binding */ TIME_LAPSE_LIMIT; },
/* harmony export */   "Y8": function() { return /* binding */ practiceActionTypes; },
/* harmony export */   "ad": function() { return /* binding */ LANGUAGE; },
/* harmony export */   "cq": function() { return /* binding */ PRACTICE_MIN_QUESTION_NUM; },
/* harmony export */   "gi": function() { return /* binding */ DEFAULT_LANGUAGE_INFO; },
/* harmony export */   "jb": function() { return /* binding */ DEFAULT_DAILY_GOAL; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lz": function() { return /* binding */ DAILY_REMINDER_OPTIONS; },
/* harmony export */   "nI": function() { return /* binding */ PRACTICE_FLOW_TYPE; },
/* harmony export */   "oH": function() { return /* binding */ DPP_INCOMPLETE; },
/* harmony export */   "oZ": function() { return /* binding */ SKIP_REASONS; },
/* harmony export */   "pj": function() { return /* binding */ DEFAULT_TIME; },
/* harmony export */   "qu": function() { return /* binding */ DEFAULT_TIME_IN_TEXT; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
/* unused harmony exports getHoursOptions, getRoundedGTPPracticeQuestionCount, DPP_PREFERENCES_QUESTION, PRACTICE_SETTINGS_CLICKED */
/* harmony import */ var _constants_practice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);



var noPrefrenceCode = -1;
var LANGUAGE = {
    ALL: {
        display_name: "All",
        code: 0
    }
};
var DEFAULT_LANGUAGE_INFO = {
    user_preference: 0,
    available_languages: [],
    language_selection_available: false
};
var PRACTICE_TYPE = {
    FULL: 1,
    EACH_TOPIC: 2,
    PYQ: 3,
    TEXTBOOK: 4,
    INCORRECT: 5
};
var PRACTICE_FLOW_TYPE = {
    NORMAL_PRACTICE: "1",
    CLASS_PRACTICE: "2",
    SYLLABUS_PRACTICE: "3",
    AUTO_DPP: "4"
};
var DISLIKE_REASONS = [
    "Mistake in the question/option choices",
    "Mistake in solution",
    "Technical issue",
    "Plagiarism"
];
var YEAR_FILTER_TYPE = {
    ALL: "all-filter"
};
var SKIP_REASONS = [
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIFFICULT_QUESTION */ .X.DIFFICULT_QUESTION,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/thinking-face.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIDNT_UNDERSTAND */ .X.DIDNT_UNDERSTAND,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/confused.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.HAVENT_STUDIED */ .X.HAVENT_STUDIED,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/exclamation-question.svg")
    }
];
var REVIEW_TYPE = {
    POSITIVE: 1,
    NEGATIVE: 2
};
var SUBJECTS = {
    ALL: -1
};
var MAX_QUESTIONS = 30;
var MIN_QUESTIONS = 5;
var FEEDBACK_OPTIONS_MAPPING = {
    POSITIVE: {
        QUALITY_OF_SOLUTIONS: 496,
        QUALITY_OF_QUESTIONS: 497,
        MIX_OF_QUESTIONS: 498,
        INTERFACE: 499,
        SYLLABUS: 500
    },
    NEGATIVE: {
        QUALITY_OF_SOLUTIONS: 501,
        QUALITY_OF_QUESTIONS: 502,
        MIX_OF_QUESTIONS: 503,
        INTERFACE: 504,
        SYLLABUS: 505
    }
};
var DAILY_GOALS_OPTIONS = [
    {
        value: 10,
        label: "10 questions"
    },
    {
        value: 20,
        label: "20 questions"
    },
    {
        value: 30,
        label: "30 questions"
    }
];
var getHoursOptions = function() {
    var options = [];
    var ref = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .generateHours */ .SA)({
        interval: 30
    }), twentyFourHrFormat = ref.twentyFourHrFormat, twelveHrFormat = ref.twelveHrFormat;
    twelveHrFormat.forEach(function(hour, index) {
        options.push({
            value: twentyFourHrFormat[index],
            label: hour
        });
    });
    return options;
};
var DAILY_REMINDER_OPTIONS = getHoursOptions();
var MODAL_TYPES = {
    PRACTICE_REMINDER: "PRACTICE_REMINDER"
};
var QUERY_ACTIONS = {
    SHOW_REMINDER_SETTING: "show_reminder_setting"
};
var TOOLTIP_MAP = {
    TOTAL_QUESTION_LIMIT_REACHED: "Total questions limit reached",
    CANNOT_ADD_MORE_QUESTIONS: "Cannot add more questions",
    NULL: ""
};
var PRACTICE_MIN_QUESTION_NUM = 5;
var getRoundedGTPPracticeQuestionCount = function(count) {
    return Math.floor(count / 100) * 100;
};
var practiceActionTypes = {
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA"
};
var MAX_PRACTICE_SESSION_COUNT = 5;
var TIME_LAPSE_LIMIT = 7;
var DEFAULT_DAILY_GOAL = 10;
var DEFAULT_TIME = "09:00";
var DEFAULT_TIME_IN_TEXT = "09:00 AM";
var DPP_SET_REMINDER_CARD_VIEWED = "DPP - Set Reminder Card Viewed ";
var DPP_SET_REMINDER_CLICKED = "DPP - Set Reminder Clicked";
var DPP_PREFERENCES_QUESTION = "DPP - Preferences Question";
var PRACTICE_SETTINGS_CLICKED = "Practice - Settings Clicked";
var DPP_COMPLETED = 1;
var DPP_INCOMPLETE = 0;


/***/ }),

/***/ 11532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HomePage_Topics; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/H4/H4.jsx
var H4 = __webpack_require__(64250);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/models/User.js
var User = __webpack_require__(81570);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/utils/isEmptyObject.js
var isEmptyObject = __webpack_require__(9759);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/H3/H3.jsx
var H3 = __webpack_require__(82034);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/constants/getTopicGroupAssetObj.js
var getTopicGroupAssetObj = __webpack_require__(77608);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/HomePage/TopicCard.tsx
var TopicCard = __webpack_require__(17093);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/components/Composite/Dropdown/Dropdown.jsx
var Dropdown = __webpack_require__(8477);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var constants = __webpack_require__(17064);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/TopicFilters.jsx










var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ek6lstj0",
    label: "DropdownWrapper"
})("grid-column:span 18;display:grid;grid-template-columns:repeat(18,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
var AppMessageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ek6lstj1",
    label: "AppMessageWrapper"
})("width:1136px;margin:auto;display:flex;align-items:center;margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ek6lstj2",
    label: "IconWrapper"
})("position:relative;width:24px;height:24px;margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var TopicFilters = function(param) {
    var subjectOptions = param.subjectOptions, educatorOptions = param.educatorOptions, onSubjectSelection = param.onSubjectSelection, onEducatorSelection = param.onEducatorSelection, selectedSubject = param.selectedSubject, selectedEducator = param.selectedEducator, goalUID = param.goalUID;
    var handleSubjectSelect = function(option) {
        onSubjectSelection(option.value);
        analytics/* segment.track */.EX.track(segment/* TOPIC_SUBJECT_FILTER_CLICKED */.CZe, {
            subject_selected: option.value
        });
    };
    var handleEducatorSelect = function(option) {
        onEducatorSelection(option.value);
        analytics/* segment.track */.EX.track(segment/* TOPIC_EDUCATOR_FILTER_CLICKED */.yZR, {
            educator_selected: option.value
        });
    };
    var getSelectedSubject = function() {
        return subjectOptions.find(function(subject) {
            return subject.value === selectedSubject;
        });
    };
    var getSelectedEducator = function() {
        return educatorOptions.find(function(educator) {
            return educator.value === selectedEducator;
        });
    };
    var isRecordedContentPlayAllowed = (0,useConstants/* default */.Z)((0,constants/* getIsRCPlayAllowed */.dk)(goalUID));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropdownWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                        // @ts-ignore
                        options: subjectOptions,
                        onOptionClick: handleSubjectSelect,
                        selectedOption: getSelectedSubject(),
                        buttonWidth: "100%"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                        // @ts-ignore
                        options: educatorOptions,
                        onOptionClick: handleEducatorSelect,
                        selectedOption: getSelectedEducator(),
                        buttonWidth: "100%"
                    })
                ]
            }),
            !isRecordedContentPlayAllowed ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecordedGoalAppMessage, {}) : null
        ]
    });
};
var RecordedGoalAppMessage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppMessageWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: "/gtp/app.svg",
                    alt: "benefit",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H5/* default */.Z, {
                children: "Lessons are only available over the Android app"
            })
        ]
    });
};
/* harmony default export */ var HomePage_TopicFilters = (TopicFilters);

;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/Topics.tsx

/* eslint-disable @next/next/link-passhref */ 














var TopicGroupOuterWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1n4lwmb0",
    label: "TopicGroupOuterWrapper"
})("grid-column:span 20;");
var TopicGroupWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1n4lwmb1",
    label: "TopicGroupWrapper"
})("margin-bottom:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";&:last-child{margin-bottom:0;}");
var TopicGroupName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1n4lwmb2",
    label: "TopicGroupName"
})("display:flex;align-items:center;margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var StyH4 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "e1n4lwmb3",
    label: "StyH4"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var TopicCardsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1n4lwmb4",
    label: "TopicCardsWrapper"
})("display:flex;flex-wrap:wrap;gap:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " ", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var Empty = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1n4lwmb5",
    label: "Empty"
})("grid-column:span 18;text-align:center;margin-top:", styleConstants/* Spacings.SPACING_24B */.t8.j2, ";");
var NoCourses = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H3/* default */.Z, {
    target: "e1n4lwmb6",
    label: "NoCourses"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, ";");
var EmptyImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e1n4lwmb7",
    label: "EmptyImage"
})("user-drag:none;user-select:none;");
var getAuthorName = function(topic) {
    var displayAuthor = topic.displayAuthor, authors = topic.authors;
    var firstName = displayAuthor.firstName, lastName = displayAuthor.lastName;
    var fullName = (0,User/* getFullName */.Pp)(firstName, lastName);
    if (authors.length > 1) {
        return "".concat(fullName, " & ").concat(authors.length - 1, " more");
    }
    return fullName;
};
var renderEmptyState = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Empty, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyImage, {
                src: "".concat((0,imageHelper/* getImage */.gJ)("gtp/no-results.svg")),
                alt: ""
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoCourses, {
                children: "No lessons found"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P2/* default */.Z, {
                color: "var(--color-text-secondary)",
                children: "There are no videos here. Try changing the filters"
            })
        ]
    });
};
var Topics = function(param) {
    var goalUID = param.goalUID, goalSlug = param.goalSlug, topicUID = param.topicUID, _data = param.data, data = _data === void 0 ? [] : _data, educatorUID = param.educatorUID, educatorUsername = param.educatorUsername, topicCardClick = param.topicCardClick, onEducatorSelection = param.onEducatorSelection, topicFilters = param.topicFilters, selectedEducator = param.selectedEducator, isRecordedGoal = param.isRecordedGoal, source = param.source, isGTP = param.isGTP, isLoading = param.isLoading;
    var topicCardsRef = react.useRef(null);
    var ref = (0,react.useState)("all"), selectedSubject = ref[0], setSelectedSubject = ref[1];
    (0,react.useEffect)(function() {
        if (topicUID) {
            var moveToTopicGroupTimer = setTimeout(function() {
                var ref;
                window.scrollTo({
                    top: ((ref = topicCardsRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 72,
                    behavior: "smooth"
                });
            }, 200);
            return function() {
                return clearTimeout(moveToTopicGroupTimer);
            };
        }
    }, [
        topicUID
    ]);
    var onTopicCardClick = function(topic) {
        return function() {
            if (topicCardClick) topicCardClick(topic);
        };
    };
    var getHref = function(uid, topic) {
        if (source === segment/* NOTES */.bxy) {
            return "/goal/".concat(goalSlug, "/").concat(goalUID, "/notes/").concat(uid, "/").concat(topic.uid);
        }
        if (educatorUID && educatorUsername) return "/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(uid, "/").concat(topic.uid, "?educatorUID=").concat(educatorUID, "&educatorUsername=").concat(educatorUsername);
        return "/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(uid, "/").concat(topic.uid);
    };
    var renderTopicCard = function(topic, color) {
        if ((0,isEmptyObject/* default */.Z)(topic)) return null;
        var title = topic.title, name = topic.name, uid = topic.uid, totalSubItem = topic.totalSubItem, childrenCount = topic.childrenCount, educatorCoveredTopic = topic.educatorCoveredTopic, isEpubAvailable = topic.isEpubAvailable, isNotesAvailable = topic.isNotesAvailable;
        var educatorName = isRecordedGoal ? getAuthorName(topic) : "";
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicCard/* default */.Z, {
            topicUID: uid,
            title: title || name,
            chaptersCount: totalSubItem || childrenCount || 0,
            onClick: onTopicCardClick(topic),
            color: color,
            countSubtext: isGTP && "sub-system",
            educatorCoveredTopic: educatorCoveredTopic,
            isEpubAvailable: isEpubAvailable,
            isNotesAvailable: isNotesAvailable,
            source: source,
            educatorName: educatorName
        });
    };
    var displayData = selectedSubject === "all" || !isRecordedGoal ? data : data.filter(function(topicGroup) {
        return topicGroup.uid === selectedSubject;
    });
    var hasData = displayData.some(function(topicGroups) {
        return topicGroups === null || topicGroups === void 0 ? void 0 : topicGroups.children.some(function(topic) {
            return !(0,isEmptyObject/* default */.Z)(topic);
        });
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopicGroupOuterWrapper, {
        children: [
            isRecordedGoal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_TopicFilters, {
                subjectOptions: topicFilters === null || topicFilters === void 0 ? void 0 : topicFilters.subjectOptions,
                educatorOptions: topicFilters === null || topicFilters === void 0 ? void 0 : topicFilters.educatorOptions,
                onSubjectSelection: setSelectedSubject,
                onEducatorSelection: onEducatorSelection,
                selectedSubject: selectedSubject,
                selectedEducator: selectedEducator,
                goalUID: goalUID
            }),
            displayData.map(function(topicGroups) {
                var _title = topicGroups.title, title = _title === void 0 ? "" : _title, _children = topicGroups.children, children = _children === void 0 ? [] : _children, uid = topicGroups.uid, _educatorCoveredTopicGroup = topicGroups.educatorCoveredTopicGroup, educatorCoveredTopicGroup = _educatorCoveredTopicGroup === void 0 ? true : _educatorCoveredTopicGroup, _name = topicGroups.name, name = _name === void 0 ? "" : _name;
                var icon = (0,getTopicGroupAssetObj/* default */.Z)(title || name).icon;
                var color = (0,getTopicGroupAssetObj/* default */.Z)(title || name).color;
                var hasTopics = topicGroups === null || topicGroups === void 0 ? void 0 : topicGroups.children.some(function(topic) {
                    return !(0,isEmptyObject/* default */.Z)(topic);
                });
                if (!educatorCoveredTopicGroup || !hasTopics) return null;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopicGroupWrapper, {
                    ref: uid === topicUID ? topicCardsRef : null,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopicGroupName, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                    height: styleConstants/* Spacings.SPACING_10B */.t8.FC,
                                    width: styleConstants/* Spacings.SPACING_10B */.t8.FC,
                                    alt: "syllabus",
                                    src: icon
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH4, {
                                    "data-testid": "topicgroup-name",
                                    children: topicGroups.title || topicGroups.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicCardsWrapper, {
                            children: children.map(function(topic) {
                                var _educatorCoveredTopic = topic.educatorCoveredTopic, educatorCoveredTopic = _educatorCoveredTopic === void 0 ? true : _educatorCoveredTopic, _isEpubAvailable = topic.isEpubAvailable, isEpubAvailable = _isEpubAvailable === void 0 ? true : _isEpubAvailable, isNotesAvailable = topic.isNotesAvailable;
                                // Used in Notes Page
                                if (source === segment/* NOTES */.bxy && (isEpubAvailable || isNotesAvailable)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: getHref(uid, topic),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        target: "_blank",
                                        id: "".concat(topic.uid, "-").concat(uid),
                                        children: renderTopicCard(topic, color)
                                    })
                                }, "".concat(topic.uid, "-").concat(uid));
                                // Used in Syllabus and Educator Profile Page
                                if (educatorCoveredTopic && isEpubAvailable && !(0,isEmptyObject/* default */.Z)(topic)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: getHref(uid, topic),
                                    id: "".concat(topic.uid, "-").concat(uid),
                                    children: renderTopicCard(topic, color)
                                }, "".concat(topic.uid, "-").concat(uid));
                                // Used in Educator Profile Page
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: renderTopicCard(topic, color)
                                });
                            })
                        })
                    ]
                }, uid);
            }),
            !hasData && !isLoading && isRecordedGoal && renderEmptyState()
        ]
    });
};
Topics.defaultProps = {
    topicUID: "",
    educatorUID: "",
    educatorUsername: "",
    onEducatorSelection: function() {},
    topicFilters: {
        educatorOptions: [],
        subjectOptions: []
    },
    selectedEducator: "",
    isRecordedGoal: false,
    source: "",
    topicCardClick: function() {},
    isLoading: false
};
/* harmony default export */ var HomePage_Topics = (Topics);


/***/ }),

/***/ 92542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M32.767 56.1c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.767-12.767c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 11 10.933 25.467-25.433c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-27.233 27.2c-0.434 0.49-1.064 0.798-1.766 0.8h-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 29558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        path: "M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7474 9.41495 20.7193 6.93654 18.8914 5.10863C17.0635 3.28073 14.5851 2.25265 12 2.25ZM17 9.47L10.9 15.59C10.7595 15.7307 10.5688 15.8098 10.37 15.81C10.1716 15.8077 9.98173 15.7289 9.84 15.59L7 12.72C6.85955 12.5794 6.78066 12.3888 6.78066 12.19C6.78066 11.9912 6.85955 11.8006 7 11.66C7.06895 11.5892 7.15137 11.533 7.24239 11.4946C7.33342 11.4562 7.43121 11.4364 7.53 11.4364C7.6288 11.4364 7.72659 11.4562 7.81762 11.4946C7.90864 11.533 7.99106 11.5892 8.06 11.66L10.37 14L16 8.41C16.069 8.33924 16.1514 8.28301 16.2424 8.24461C16.3334 8.20621 16.4312 8.18643 16.53 8.18643C16.6288 8.18643 16.7266 8.20621 16.8176 8.24461C16.9086 8.28301 16.9911 8.33924 17.06 8.41C17.1258 8.4835 17.1764 8.56924 17.2089 8.66232C17.2415 8.7554 17.2554 8.85399 17.2498 8.95244C17.2443 9.0509 17.2193 9.14729 17.1765 9.2361C17.1336 9.32491 17.0736 9.40439 17 9.47Z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var KeyboardArrowDown = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M39.8 52.033c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-20-20c-0.49-0.458-0.796-1.108-0.796-1.829 0-1.381 1.119-2.5 2.5-2.5 0.721 0 1.371 0.306 1.828 0.794l0.001 0.001 18.233 18.233 18.233-18.233c0.445-0.416 1.045-0.671 1.704-0.671 1.381 0 2.5 1.119 2.5 2.5 0 0.659-0.255 1.259-0.672 1.706l0.001-0.001-20 20c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (KeyboardArrowDown);


/***/ }),

/***/ 11238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SKIP_REASONS_MAP; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var SKIP_REASONS_MAP = {
    DIFFICULT_QUESTION: "Difficult Question",
    DIDNT_UNDERSTAND: "Didn't Understand",
    HAVENT_STUDIED: "Haven't studied"
};


/***/ }),

/***/ 88268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JL": function() { return /* binding */ ScheduleItemTypeLabel; },
/* harmony export */   "Tc": function() { return /* binding */ scheduleItemStatus; },
/* harmony export */   "ft": function() { return /* binding */ ScheduleItemStatusLabel; },
/* harmony export */   "hc": function() { return /* binding */ scheduleItemTypes; },
/* harmony export */   "pt": function() { return /* binding */ plannerEventTypes; }
/* harmony export */ });
/* unused harmony export ScheduleItemRankLabel */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var scheduleItemStatus = {
    MISSED: 1,
    WATCHED_OR_ATTEMPTED: 2,
    UPCOMING: 3,
    CANCELLED: 4
};
var _obj;
var ScheduleItemStatusLabel = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.MISSED, "missed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.WATCHED_OR_ATTEMPTED, "completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.UPCOMING, "upcoming"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.CANCELLED, "cancelled"), _obj);
var scheduleItemTypes = {
    CLASS: 1,
    QUIZ: 2,
    COMBAT: 3,
    TEST: 4,
    LIVE_INTERACTION: 5,
    OPENHOUSE: 6,
    DAILY_PRACTICE_REMINDER: 7
};
var _obj1;
var ScheduleItemTypeLabel = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.CLASS, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.CLASS */ .cs.CLASS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.QUIZ, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.QUIZ */ .cs.QUIZ), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.TEST, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.TEST */ .cs.TEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.COMBAT, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.COMBAT */ .cs.COMBAT), _obj1);
var _obj2;
var ScheduleItemRankLabel = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.CLASS, "Lesson"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.QUIZ, "Quiz"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.COMBAT, "Combat"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.TEST, "Test"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.LIVE_INTERACTION, "Live Interaction"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.OPENHOUSE, "Openhouse"), _obj2);
// categorized based on their height
var plannerEventTypes = {
    CLASS: "class",
    CLASS_WITH_PRACTICE: "class_with_practice",
    TEST: "test",
    TEST_WITH_EDUCATOR: "test_with_educator",
    QUIZ: "quiz",
    COMBAT: "combat",
    LIVE_INTERACTION: "live_interaction",
    DAILY_PRACTICE_REMINDER: "daily_practice_reminder",
    OPENHOUSE: "openhouse",
    OFFLINE_TEST: "offline_test"
};


/***/ }),

/***/ 56046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ getTopicGroup; },
/* harmony export */   "Bc": function() { return /* binding */ isSummitClass; },
/* harmony export */   "PN": function() { return /* binding */ isCompleted; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Zz": function() { return /* binding */ isUpcoming; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "fr": function() { return /* binding */ isOngoing; },
/* harmony export */   "k$": function() { return /* binding */ getInfoString; },
/* harmony export */   "mI": function() { return /* binding */ getDefaultThumbnail; }
/* harmony export */ });
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46571);




var getInfoString = function(course) {
    var liveAt = course.liveAt || course.startsAt;
    if (!liveAt) return "";
    var infoString = "";
    if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.COMPLETED */ .MZ.COMPLETED) {
        infoString = "".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getTimeFormatInShortFormWithoutSecs */ .ZP.getTimeFormatInShortFormWithoutSecs(course.lessonDuration));
    } else if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.LIVE */ .MZ.LIVE) {
        infoString = "Started on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    }
    infoString = "Starts on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    return infoString;
};
var isUpcoming = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() > now.getTime();
};
var getDefaultThumbnail = function(course) {
    // To not show plus thumbnail if it's a free course
    if ((course.for_plus || course.forPlus) !== false && (course.programme_type || course.programmeType) === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES) {
        return "https://static.uacdn.net/thumbnail/course/testseries-placeholder.png";
    }
    return null;
};
var isOngoing = function(startsAt, endsAt) {
    if (!startsAt || !endsAt) return false;
    var now = new Date();
    return new Date(startsAt).getTime() < now.getTime() && new Date(endsAt).getTime() > now.getTime();
};
var isCompleted = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() < now.getTime();
};
var isSummitClass = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return ((ref = data.goal) === null || ref === void 0 ? void 0 : ref.uid) === "DCGBT";
};
function courseModel(course) {
    var ref, ref1, ref2, ref3, ref4;
    var topicGroups = course.topic_groups || [
        course.topic_group
    ];
    var _state;
    var data = {
        uid: course.uid,
        name: course.name,
        isPartOfBatch: course.is_part_of_batch,
        thumbnail: course.cover_photo_v1 || course.thumbnail_v1 || course.thumbnail || course.cover_photo || getDefaultThumbnail(course),
        newThumbnail: course.cover_photo_v1,
        description: course.description || null,
        permalink: course.permalink,
        relativeLink: course.relative_link,
        averageRating: course.avg_rating,
        slug: course.slug,
        isActive: course.is_active,
        totalReviews: course.total_reviews,
        totalRatings: course.total_ratings,
        forPlus: course.for_plus || course.for_subscription,
        forSubscription: course.for_subscription,
        livestreamUrl: course.livestream_url,
        totalTime: course.total_time,
        totalSessionTime: course.total_session_time,
        viewCount: course.view_count,
        savedCount: course.saved_count,
        previewVideo: course.intro_video,
        language: (course === null || course === void 0 ? void 0 : course.language_display) || (course === null || course === void 0 ? void 0 : (ref = course.multiple_language_display) === null || ref === void 0 ? void 0 : ref[0]),
        liveClassCount: course.sessions_count,
        isEnrolled: course.is_enrolled,
        isBookmarked: course.bookmarked,
        isSpecial: course.is_special,
        isIconic: course.is_iconic,
        enrollmentCount: course.enrollment_count,
        secondaryType: course.secondary_type,
        courseType: course.programme_type,
        isLive: course.is_live,
        state: (_state = course.state) !== null && _state !== void 0 ? _state : course.status,
        liveClassesRemaining: course.sessions_remaining,
        itemCount: course.all_item_count || course.item_count,
        lessonsWatched: course.lessons_watched,
        lessonsCompleted: course.lessons_completed,
        startsAt: course.starts_at,
        endsAt: course.ends_at,
        isUpcoming: isUpcoming(course.starts_at),
        isOngoing: isOngoing(course.starts_at, course.ends_at),
        isCompleted: course.is_completed || isCompleted(course.ends_at),
        quizCount: course.all_item_count - course.sessions_count,
        channelDetails: course.channel,
        nextTrack: {
            item: course.next_track || course.next_session || course.next_class || course.next_item
        },
        previousTrack: {
            item: course.previous_session
        },
        authors: course.authors ? course.authors.map(function(author) {
            return {
                user: author
            };
        }) : [
            {
                user: course.author
            }
        ],
        topicGroups: topicGroups ? topicGroups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        topic: course === null || course === void 0 ? void 0 : (ref1 = course.topic_groups) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
        conceptTopology: course === null || course === void 0 ? void 0 : (ref3 = course.concept_topology) === null || ref3 === void 0 ? void 0 : ref3.name,
        coverPhoto: course.cover_photo_v1 || course.cover_photo || course.thumbnail || getDefaultThumbnail(course),
        colorCode: course.color_code,
        goal: course.goal ? {
            topology: course.goal
        } : null,
        topologies: course.topologies ? course.topologies.map(function(topologyItem) {
            return {
                topology: topologyItem
            };
        }) : null,
        goalUid: course.goal_uid || ((ref4 = course.goal) === null || ref4 === void 0 ? void 0 : ref4.uid) || null,
        liveClasses: course.live_classes ? course.live_classes.map(function(itemData) {
            return {
                item: itemData
            };
        }) : null,
        tag: course.tag,
        unLiveUrl: course.unlive_url,
        progress: course.progress,
        conceptLessonCount: course.lesson_count,
        ogImage: course.og_image || null,
        type: course.type || "",
        voiceLanguages: course.voiceLanguages,
        contentSlideLanguages: course.contentSlideLanguages,
        batchGroup: course.batch_group || null,
        totalDPPCount: (course === null || course === void 0 ? void 0 : course.total_practice_dpp_count) || 0,
        queryID: course.queryID,
        requestID: course.requestID,
        index: course.index,
        isRecordedClassesOnlyCourse: !course.is_live_class_present
    };
    if (course.progress) {
        data.progress.nextLessonRelativeLink = course.progress.next_lesson_relative_link;
        data.progress.isCompleted = parseInt(course.progress.percentage, 2) === 100;
    }
    if (course.programme) {
        data.isRecordedClassesOnlyCourse = !course.programme.is_live_class_present;
    }
    data.infoString = getInfoString(data);
    return data;
}
function getEntityData(data) {
    return courseModel(data);
}
var getTopicGroup = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.topicGroups ? data.topicGroups[0] : null;
};
var getAuthorsName = function(authors) {
    if (!authors) return "";
    var nameText = authors.slice(0, 3).reduce(function(initial, educator, index) {
        if (index === 1) return initial + educator.name;
        if (index < 2 && authors.length === 1) return initial + educator.name;
        if (index < 2) return "".concat(initial, " ").concat(educator.name, ", ");
        return "".concat(initial, " and ").concat(authors.length - 2, " more");
    }, "");
    return nameText;
};
var getLinkPath = function(data) {
    // if course is special
    if (data.isSpecial || data.showAsLesson) {
        var ref, ref1;
        // if a course is special class and inside properties of nextTrack/nextSession uid and relativeLink is available then use class link instead of course link to save redirect from course to class
        var nextTrack = data.nextTrack;
        if (nextTrack && ((nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.uid) || (nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.properties) === null || ref === void 0 ? void 0 : ref.uid) && (nextTrack === null || nextTrack === void 0 ? void 0 : (ref1 = nextTrack.properties) === null || ref1 === void 0 ? void 0 : ref1.relativeLink))) {
            return "/class/[slug]/[uid]";
        }
        return "/course/[slug]/[courseUID]";
    }
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    // lesson - Free course
    if (!forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    // checking whether the passed object is course or item. (item)
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST) {
        // if item and plus item means a class
        if (forPlus) return "/class/[slug]/[uid]";
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/[slug]/[courseUID]/";
    }
    return "/course/[slug]/[courseUID]/";
};
var getLink = function(data) {
    if (data.isSpecial || data.showAsLesson) return (0,_Item__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(data);
    if (!data.forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return data.progress.nextLessonRelativeLink;
    }
    var slug = data.slug;
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    if (!slug) {
        var ref;
        var courseName = (ref = data.name) === null || ref === void 0 ? void 0 : ref.replace(/\/|\\/g, " ");
        slug = _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStringWordsJoinedWith */ .ZP.getStringWordsJoinedWith(courseName, "-");
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/".concat(slug, "/").concat(data.uid);
    }
    return "/".concat(type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST ? forPlus && "class" || "lesson" : "course", "/").concat(slug, "/").concat(data.uid);
};
var course = {
    Course: courseModel,
    getEntityData: getEntityData,
    getAuthorsName: getAuthorsName,
    getTopicGroup: getTopicGroup,
    getLink: getLink,
    getLinkPath: getLinkPath,
    isSummitClass: isSummitClass
};
/* harmony default export */ __webpack_exports__["ZP"] = (course);


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getTopicLinkHref; },
/* harmony export */   "EN": function() { return /* binding */ getSpecialClassesLinkHref; },
/* harmony export */   "Ho": function() { return /* binding */ getHrefAndAsOfAFreeCourse; },
/* harmony export */   "Hw": function() { return /* binding */ getLinkHref; },
/* harmony export */   "Lb": function() { return /* binding */ getSpecialClassesLink; },
/* harmony export */   "Po": function() { return /* binding */ getSpecialClassesAllLink; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "TW": function() { return /* binding */ getCoursesHref; },
/* harmony export */   "UP": function() { return /* binding */ getBrowseLink; },
/* harmony export */   "_Y": function() { return /* binding */ getYoutubeLessonLink; },
/* harmony export */   "b4": function() { return /* binding */ getCoursesAsPath; },
/* harmony export */   "bU": function() { return /* binding */ getYoutubeCourseLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "dF": function() { return /* binding */ getTopicListLink; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "pA": function() { return /* binding */ getTopicLink; },
/* harmony export */   "s3": function() { return /* binding */ getTopicListHref; },
/* harmony export */   "v9": function() { return /* binding */ getGtpFreeClassesAllLink; },
/* harmony export */   "vX": function() { return /* binding */ getHrefAndAsOfSaved; },
/* harmony export */   "vx": function() { return /* binding */ getPannerLink; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports topologyModal, getBrowseLinkAs, getBrowseLinkHref, getPlannerLinkAs, plannerLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);



function topologyModal(topology) {
    var ref;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    return {
        uid: topology.uid,
        name: topology.name,
        permalink: topology.permalink,
        relativeLink: topology.relative_link,
        goalSlug: topology.slug,
        title: topology.title,
        coursesCount: topology.courses_count || topology.item_count || topology.count || topology.plus_course_count || topology.course_count || 0,
        upcomingCoursesCount: topology.upcoming_count || 0,
        upcomingCoursesThisMonth: topology.upcoming_this_month || 0,
        enrolledCoursesCount: topology.enrolled_count || 0,
        totalSubItem: topology.total_subItem || 0,
        progress: topology.progress || 0,
        color: topology.color,
        plusCourseCount: topology.plusCourseCount || topology.total_count || 0,
        colorCode: topology.color_code,
        level: topology.level,
        fullName: topology.title,
        icon: topology.icon,
        children: topology.children,
        slug: topology.slug || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .getStringWordsJoinedWith */ .kL)(topology.name, "-"),
        parent: topology.parent,
        isPracticeAvailable: topology.is_practice_session,
        isPlusAvailable: topology.is_plus_available,
        isFreeUnavailable: topology.is_free_unavailable,
        language: topology.language || null,
        ogImage: topology.og_image || null,
        window: topology.window,
        windowCount: topology.window_count,
        selfDataFetched: topology.selfDataFetched || false,
        tags: topology.tags,
        isNoTestGoal: !!((ref = topology.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.name) === "NON_TEST_PREP";
        })),
        isIconicAvailable: topology.is_iconic_available,
        externalApps: topology.external_apps_available,
        isSyllabusV1Enabled: topology.is_syllabus_v1_enabled,
        isPlatformGoal: topology.is_platform_goal || false,
        goalLevelOnboarding: {
            isAvailable: topology.is_goal_onboarding_available || false,
            status: topology.user_onboarding_status || null,
            hideNudge: false
        },
        isLeaderdboardMetaInfoAvailable: topology.is_leaderdboard_meta_info_available,
        leaderboardFilters: topology.leaderboard_filters,
        leaderboardScreenMetaInfo: topology.leaderboard_screen_meta_info,
        isCatalogueFeatureAvailable: topology.is_catalogue_feature_available || false,
        isK12: topology.is_k12_goal || false,
        isUaIconGoal: topology.is_ua_icon_goal || false,
        isRecordedGoal: topology.is_recorded_goal,
        isCentreAvailable: topology.is_centre_available
    };
}
function getEntityData(data) {
    return topologyModal(data);
}
var getLink = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid);
};
var getBrowseLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/browse");
};
var getBrowseLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/browse";
};
var getBrowseLink = function(data) {
    return {
        as: getBrowseLinkAs(data),
        href: getBrowseLinkHref()
    };
};
var getPlannerLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/planner");
};
var plannerLink = "/goal/[goalSlug]/[goalUID]/planner";
var getPannerLink = function(data) {
    return {
        as: getPlannerLinkAs(data),
        href: plannerLink
    };
};
/**
 * Retuns link href of a generic goal
 * @returns string pattern of a generic goal href
 */ var getLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]";
};
var getTopicLink = function(topic, goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topic/").concat(topic.uid);
};
var getTopicLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getTopicListLink = function(goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topics");
};
var getTopicListHref = function() {
    return "/goal/goalSlug/goalUID/topics";
};
var getLinkPath = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getSpecialClassesLink = function(data) {
    return "".concat(getLink(data), "/classes");
};
var getSpecialClassesLinkHref = function() {
    return "".concat(getLinkHref(), "/classes");
};
var getSpecialClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes",
        as: "".concat(getLink(data), "/classes")
    };
};
var getGtpFreeClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes/[type]",
        as: "".concat(getLink(data), "/classes/all_classes")
    };
};
var getYoutubeCourseLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]",
        as: "/content/p/freecourses/".concat(data.goalUID)
    };
};
var getYoutubeLessonLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]",
        as: "/content/p/freecourses/".concat(data.goalUID, "/").concat(data.courseTitle, "/").concat(data.courseUID, "/").concat(data.lessonUID)
    };
};
var getHrefAndAsOfAFreeCourse = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/free-platform",
        as: "".concat(getLink(data), "/free-platform")
    };
};
var getHrefAndAsOfSaved = function(goal) {
    return {
        href: "".concat(getLinkHref(), "/saved"),
        as: "".concat(getLink(goal), "/saved")
    };
};
var getCoursesHref = function() {
    return "".concat(getTopicLinkHref(), "/courses");
};
var getCoursesAsPath = function(goalSlug, goalUID, topicUID) {
    return "".concat(getTopicLink({
        uid: topicUID
    }, {
        slug: goalSlug,
        uid: goalUID
    }), "/courses");
};
var _obj;
var getTopologyName = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CATEGORY */ .OP.CATEGORY, "Category"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GOAL */ .OP.GOAL, "Goal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GROUP */ .OP.GROUP, "Topic Group"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.TOPIC */ .OP.TOPIC, "Topic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CONCEPT */ .OP.CONCEPT, "Concept"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.SUBCONCEPT */ .OP.SUBCONCEPT, "Subconcept"), _obj);
var topology = {
    Topology: topologyModal,
    getEntityData: getEntityData,
    getLink: getLink,
    getLinkHref: getLinkHref,
    getSpecialClassesLink: getSpecialClassesLink,
    getLinkPath: getLinkPath,
    getTopicLink: getTopicLink,
    getTopicListLink: getTopicListLink,
    getSpecialClassesAllLink: getSpecialClassesAllLink,
    getHrefAndAsOfAFreeCourse: getHrefAndAsOfAFreeCourse,
    getTopicListHref: getTopicListHref,
    getSpecialClassesLinkHref: getSpecialClassesLinkHref,
    getTopicLinkHref: getTopicLinkHref,
    getHrefAndAsOfSaved: getHrefAndAsOfSaved,
    getTopologyName: getTopologyName
};
/* harmony default export */ __webpack_exports__["ZP"] = (topology);


/***/ }),

/***/ 81570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ isLegendEducator; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "ug": function() { return /* binding */ formatFirstName; }
/* harmony export */ });
/* unused harmony export getRelativeLink */
/* harmony import */ var _utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21848);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);


var formatFirstName = function(firstName) {
    return firstName ? firstName.toLocaleString() : "";
};
var getRelativeLink = function(user) {
    var url = "/learner/@".concat(user.username);
    if (user.is_educator || user.is_moderator) url = user.relative_link || "/@".concat(user.username);
    return url;
};
var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
function userModel(userData) {
    var user = userData.author_details ? userData.author_details : userData;
    var firstName = user.first_name ? user.first_name.toLocaleString() : "";
    var lastName = user.last_name ? user.last_name : "";
    return {
        firstName: firstName,
        lastName: lastName,
        uid: user.uid,
        isFullStoryUser: user.is_full_story_user,
        name: getFullName(firstName, lastName),
        thumbnail: user.avatar_v1 || user.avatar || null,
        description: user.bio || null,
        permalink: user.permalink,
        relativeLink: getRelativeLink(user),
        averageRating: user.avg_rating,
        username: user.username.toLowerCase() || null,
        referralInfo: user.referral_info,
        followersCount: user.followers_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.followers_count) : null,
        followingCount: user.follows_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.follows_count) : null,
        lifetimeViews: user.lifetime_views ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.lifetime_views) : null,
        starRatings: user.star_ratings ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.star_ratings) : null,
        isFollowing: user.is_following,
        postsCount: user.posts_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.posts_count) : null,
        coursesCount: user.courses_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.courses_count) : null,
        isEducator: user.is_educator,
        isModerator: user.is_moderator,
        isVerifiedEducator: user.is_verified_educator,
        isExEducator: user.is_ex_educator,
        isEmailVerified: user.is_email_verified,
        isPhoneVerified: user.is_phone_verified,
        isProfileFilled: user.is_profile_filled,
        isPlatformEducator: user.is_platform_educator,
        isPlatinumEducator: user.is_platinum_educator,
        dedications: user.dedications,
        topicsDisplay: user.topics_display,
        stats: user.stats,
        phone: user.phone,
        email: user.email,
        state: user.state,
        country: user.country,
        language: user.language,
        canAddPlusCourse: user.can_add_plus_course,
        canAddSpecialClass: user.can_add_special_class,
        verifiedEducatorAt: user.verified_educator_at,
        liveMinutes: user.live_minutes ? Math.round(user.live_minutes / 60) : 0,
        totalWatchMins: user.total_watch_time ? Math.round(user.total_watch_time / 60) : 0,
        credentials: user.credentials,
        languages: user.languages,
        becomeEducatorAt: user.become_educator_at,
        educatorType: user.educator_type,
        educatorTypeV2: user.educator_type_v2,
        knowsAbout: user.knows_about,
        levelInfo: user.level_info || {},
        levelId: user.level_id,
        dateJoined: user.date_joined,
        ogImage: user.og_image || null,
        leaderboardMetaInfo: user.leaderboard_meta_info || null,
        avatarV1: user.avatar_v1 || null,
        avatarV2: user.avatar_v2 || null,
        oldAvatar: user.old_avatar || null,
        fallbackAvatar: user.avatar || null,
        queryID: user.queryID,
        requestID: user.requestID,
        index: user.index
    };
}
function getEntityData(data) {
    return userModel(data);
}
var isLegendEducator = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.uid === "WO7LDJ3Y2Z" || data.educatorType === 4;
};
var user = {
    User: userModel,
    getEntityData: getEntityData,
    isLegendEducator: isLegendEducator
};
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 68679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ topics; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/redux/actions/topologies.js
var topologies = __webpack_require__(62282);
// EXTERNAL MODULE: ./src/layout/NavBar/PlusNavBar/plusNavBarItems.js
var plusNavBarItems = __webpack_require__(2990);
// EXTERNAL MODULE: ./src/seo/goal/subGoal.js
var subGoal = __webpack_require__(94004);
// EXTERNAL MODULE: ./src/components/Container/PlusTopics/PlusTopology.jsx + 9 modules
var PlusTopology = __webpack_require__(28665);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./src/redux/selectors/syllabus.js + 1 modules
var syllabus = __webpack_require__(10448);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
;// CONCATENATED MODULE: ./src/api/hooks/goal/topics/useSyllabus.js


/* eslint-disable react-hooks/exhaustive-deps */ 
var useSyllabus = function(goalUID, isNewSyllabus, extraParams, isRecordedGoal) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        fallbackData: undefined
    };
    var key = "v1/syllabus/".concat(isRecordedGoal ? "recorded_content_home/recorded_feed" : "home/feed", "/?goal_uid=").concat(goalUID).concat((extraParams === null || extraParams === void 0 ? void 0 : extraParams.educator_uid) ? "&educator_uid=".concat(extraParams.educator_uid) : "");
    var _ref = (0,useFetch/* default */.Z)(isNewSyllabus ? key : null, {}, {
        fallbackData: options.fallbackData
    }), syllabusData = _ref.data, isValidating = _ref.isValidating, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating"
    ]);
    return (0,_object_spread/* default */.Z)({
        key: key,
        syllabusData: syllabusData,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ var topics_useSyllabus = (useSyllabus);

// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/models/Me.js + 4 modules
var Me = __webpack_require__(92942);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/components/Base/BreadCrumbs/BreadCrumbs.jsx
var BreadCrumbs = __webpack_require__(17562);
// EXTERNAL MODULE: ./src/components/Base/H2/H2.jsx
var H2 = __webpack_require__(39396);
// EXTERNAL MODULE: ./src/utils/breadcrumbs.js
var breadcrumbs = __webpack_require__(23018);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/api/hooks/goal/useGoalInfo.js
var useGoalInfo = __webpack_require__(27200);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var subscription = __webpack_require__(83553);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/Header.tsx
















var HeaderNavBar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "en9vdba0",
    label: "HeaderNavBar"
})("margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding:", styleConstants/* Spacings.SPACING_8B */.t8.B3, " ", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{background:var(--color-base-0);box-shadow:none;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " 0 0 0;margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H2/* default */.Z, {
    target: "en9vdba1",
    label: "Title"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, ";height:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";line-height:150%;");
var sourcesType = Object.keys(constants/* PlusTopologySource */.e).map(function(key) {
    return constants/* PlusTopologySource */.e[key];
});
var headerTags = function(goalTopology, source, isGTP, isOfflineSubscription) {
    var tags = [];
    if (goalTopology) {
        var _tags;
        (_tags = tags).push.apply(_tags, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getPlusTopicsTags */.ZP.getPlusTopicsTags(goalTopology, isOfflineSubscription)));
        if (source === constants/* PlusTopologySource.TOPIC_FEED */.e.TOPIC_FEED) {
            var _tags1;
            (_tags1 = tags).push.apply(_tags1, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getTopics */.ZP.getTopics(goalTopology, isGTP)));
        }
    }
    return tags;
};
var Header = function(param) {
    var source = param.source, goalUID = param.goalUID, isGTP = param.isGTP;
    // @ts-ignore
    var ref = (0,useGoalInfo/* default */.Z)(goalUID), goalTopology = ref.goalInfo;
    var isRecordedGoal = goalTopology.isRecordedGoal;
    var ref1 = (0,router.useRouter)(), goalSlug = ref1.query.goalSlug;
    var isOfflineSubscription = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    var goBack = function() {
        (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/planner", "/goal/".concat(goalSlug, "/").concat(goalUID, "/planner"));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderNavBar, {
            gridColumn: "span 18",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* default */.Z, {
                    tags: headerTags(goalTopology, source, isGTP, isOfflineSubscription),
                    onBackClick: goBack,
                    useBackClick: true
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    children: isGTP || isRecordedGoal ? "Video lessons" : plusNavBarItems/* default.PLAYLIST */.Z.PLAYLIST
                })
            ]
        })
    });
};
var sources = Object.keys(constants/* PlusTopologySource */.e).map(function(key) {
    return constants/* PlusTopologySource */.e[key];
});
/* harmony default export */ var HomePage_Header = (Header);

// EXTERNAL MODULE: ./src/components/Container/Syllabus/HomePage/Topics.tsx + 1 modules
var Topics = __webpack_require__(11532);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js
var Slide = __webpack_require__(82285);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/FeatureIntroduction.tsx




















var Transition = /*#__PURE__*/ react.forwardRef(function Transition(props, ref) {
    // @ts-ignore
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide/* default */.Z, (0,_object_spread/* default */.Z)({
        direction: "up",
        ref: ref
    }, props));
});
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg0",
    label: "Wrapper"
})("padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " ", styleConstants/* Spacings.SPACING_6B */.t8.BY, " ", styleConstants/* Spacings.SPACING_8B */.t8.B3, " ", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var FeatureIntroduction_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg1",
    label: "Title"
})("font-size:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";font-weight:600;line-height:", styleConstants/* Spacings.SPACING_9B */.t8.No, ";margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";color:var(--color-base-fill);");
var StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1htekrg2",
    label: "StyP1"
})("max-width:384px;line-height:18px;");
var StyH6 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e1htekrg3",
    label: "StyH6"
})("line-height:18px;");
var ItemsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg4",
    label: "ItemsWrapper"
})("display:flex;flex-direction:column;justify-content:center;gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";");
var Item = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg5",
    label: "Item"
})("display:flex;flex-direction:row;align-items:center;gap:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyDialog = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Dialog/* default */.Z, {
    target: "e1htekrg6",
    label: "StyDialog"
})("&.MuiDialog-root .MuiDialog-container .MuiPaper-root{bottom:0;background:var(--color-base-0);border-radius:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";max-height:none;width:464px;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    color: "rgba(0, 0, 0, 0.12)"
}), ";}&.MuiDialog-root{overflow:scroll;}");
var InnerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg7",
    label: "InnerWrapper"
})("padding-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "e1htekrg8",
    label: "StyButton"
})("font-size:14px;border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";color:var(--color-base-1);height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:140px;");
var Images = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg9",
    label: "Images"
})("position:relative;");
var CloseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1htekrg10",
    label: "CloseIcon"
})("position:absolute;cursor:pointer;top:0;right:0;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-right:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var FeatureIntroduction = function(param) {
    var goalUID = param.goalUID, isRecordedGoal = param.isRecordedGoal;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), open = ref[0], setOpen = ref[1];
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var closeDialog = function() {
        setOpen(false);
        cookies/* default.setCookie */.ZP.setCookie("syllabusHomepageVisited", true, 180);
        analytics/* segment.track */.EX.track(segment/* SYLLABUS_GET_STARTED_CLICKED */.O$i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            last_primary_source: segment/* SYLLABUS */.ZHT,
            last_primary_source_section: "Syllabus - Feature Introduction"
        }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, segment/* SYLLABUS_CLICKED_KEYS */.Tk8);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyDialog, {
        open: open,
        // @ts-ignore
        TransitionComponent: Transition,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Images, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                            src: "syllabus/feature-introduction.png",
                            width: "416px",
                            height: "227px",
                            alt: "syllabus"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon, {
                            onClick: closeDialog,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                src: "syllabus/close-icon.svg",
                                width: styleConstants/* Spacings.SPACING_7B */.t8.d5,
                                height: styleConstants/* Spacings.SPACING_7B */.t8.d5,
                                alt: "syllabus"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIntroduction_Title, {
                            children: isRecordedGoal ? "Video lessons" : plusNavBarItems/* default.PLAYLIST */.Z.PLAYLIST
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyP1, {
                            color: "var(--color-text-secondary)",
                            children: "High quality classes on your entire syllabus along with notes & practice questions"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemsWrapper, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                            src: "syllabus/compass.png",
                                            width: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            height: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            alt: "syllabus"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH6, {
                                            children: "All your subjects in one place"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                            src: "syllabus/play.png",
                                            width: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            height: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            alt: "syllabus"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH6, {
                                            children: "Classes organized by topics & chapters"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                            src: "syllabus/notes-icon.png",
                                            width: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            height: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            alt: "syllabus"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH6, {
                                            children: "Notes & practice questions for revision"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyButton, {
                            // @ts-ignore
                            label: "Get started",
                            color: "black",
                            maxHeight: "xs",
                            width: "90px",
                            onClick: closeDialog
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_FeatureIntroduction = (FeatureIntroduction);

// EXTERNAL MODULE: ./src/components/Base/H3/H3.jsx
var H3 = __webpack_require__(82034);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/PreSubscriptionBanner.tsx









var PreSubscriptionBanner_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1eh8kks0",
    label: "Wrapper"
})("background:rgb(8,189,128,0.1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";grid-column:span 18;display:flex;margin-top:-", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";background-image:", function(param) {
    var $isGTP = param.$isGTP;
    return "url(".concat((0,imageHelper/* getImage */.gJ)($isGTP ? "syllabus/pre-subscribed_plus.png" : "syllabus/pre-subscribed_iconic.svg"), ")");
}, ";background-repeat:no-repeat;background-position:right bottom;background-size:280px 252px;");
var InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1eh8kks1",
    label: "InfoWrapper"
})("padding:", styleConstants/* Spacings.SPACING_12B */.t8.SL, " 0 ", styleConstants/* Spacings.SPACING_12B */.t8.SL, " ", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";max-width:480px;");
var PreSubscriptionBanner_StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1eh8kks2",
    label: "StyP1"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";line-height:", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";");
var StyH3 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H3/* default */.Z, {
    target: "e1eh8kks3",
    label: "StyH3"
})("line-height:", styleConstants/* Spacings.SPACING_7B */.t8.d5, ";");
var PreSubscriptionBanner = function(param) {
    var title = param.title, description = param.description, handleButtonClick = param.handleButtonClick, isGTP = param.isGTP;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreSubscriptionBanner_Wrapper, {
        $isGTP: isGTP,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH3, {
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreSubscriptionBanner_StyP1, {
                    color: "var(--color-i-gray)",
                    children: description
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                    // @ts-ignore
                    label: "Get subscription",
                    onClick: handleButtonClick
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_PreSubscriptionBanner = (PreSubscriptionBanner);

;// CONCATENATED MODULE: ./src/components/Container/Syllabus/HomePage/HomePage.tsx



/* eslint-disable @next/next/link-passhref */ 














var HomePage = function(param) {
    var source = param.source, goalUID = param.goalUID, topicUID = param.topicUID, isGTP = param.isGTP, topicFilters = param.topicFilters, isRecordedGoal = param.isRecordedGoal;
    var ref = (0,react.useState)("all"), selectedEducator = ref[0], setSelectedEducator = ref[1];
    var endpointParams = (0,react.useMemo)(function() {
        if (selectedEducator !== "all" && isRecordedGoal) {
            return {
                educator_uid: selectedEducator
            };
        }
        return {};
    }, [
        selectedEducator,
        isRecordedGoal
    ]);
    var query = (0,router.useRouter)().query;
    var goalSlug = query.goalSlug;
    var isSyllabusVisited = cookies/* default.readCookie */.ZP.readCookie("syllabusHomepageVisited", false);
    var isSubscribed = (0,useMyInfo/* default */.Z)(Me/* getActiveUidsByType */.Zi).includes(goalUID.toUpperCase());
    var ref1 = topics_useSyllabus(goalUID, true, endpointParams, isRecordedGoal, {
        fallbackData: undefined
    }), syllabusData = ref1.syllabusData, isLoading = ref1.isLoading;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var topicCardClick = function(topic) {
        var title = topic.title, level = topic.level;
        analytics/* segment.track */.EX.track(segment/* SYLLABUS_CARD_CLICKED */.OB2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            last_primary_source: segment/* SYLLABUS */.ZHT,
            last_primary_source_section: "Syllabus",
            topology_name: title,
            topology_level: level
        }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, segment/* SYLLABUS_CLICKED_KEYS */.Tk8);
    };
    var handleGetSubscription = function() {
        analytics/* segment.track */.EX.track(segment/* CHECKOUT_STARTED */.mOH, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            last_primary_source_section: "Get subscription banner"
        }));
        (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/subscribe", "/goal/".concat(goalSlug, "/").concat(goalUID, "/subscribe"));
    };
    var handleEducatorSelection = function(educatorUid) {
        setSelectedEducator(educatorUid);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_Header, {
                source: source,
                goalUID: goalUID,
                isGTP: isGTP
            }),
            !isSubscribed && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_PreSubscriptionBanner, {
                title: "Learn with structured lessons",
                description: "The subscription unlocks high quality lecture videos for the entire syllabus for all your subjects",
                handleButtonClick: handleGetSubscription,
                isGTP: isGTP
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Topics/* default */.Z, {
                goalUID: goalUID,
                goalSlug: goalSlug,
                data: syllabusData === null || syllabusData === void 0 ? void 0 : syllabusData.data,
                topicUID: topicUID,
                topicCardClick: topicCardClick,
                onEducatorSelection: handleEducatorSelection,
                topicFilters: topicFilters,
                selectedEducator: selectedEducator,
                isRecordedGoal: isRecordedGoal,
                isGTP: isGTP,
                isLoading: isLoading
            }),
            !isSyllabusVisited && !isGTP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_FeatureIntroduction, {
                goalUID: goalUID,
                isRecordedGoal: isRecordedGoal
            })
        ]
    });
};
/* harmony default export */ var HomePage_HomePage = (HomePage);

// EXTERNAL MODULE: ./src/components/Container/GTP/GTPMobileBlocker.jsx
var GTPMobileBlocker = __webpack_require__(76798);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
;// CONCATENATED MODULE: ./src/api/hooks/goal/topics/useFullSyllabusInfo.js


var useFullSyllabusInfo = function(goalUID) {
    var fallbackData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, isNewSyllabus = arguments.length > 2 ? arguments[2] : void 0, isRecordedGoal = arguments.length > 3 ? arguments[3] : void 0;
    var ref = topics_useSyllabus(goalUID, isNewSyllabus, {}, isRecordedGoal, {
        fallbackData: fallbackData.syllabusData
    }), syllabusSWRKey = ref.key;
    var ref1 = (0,useGoalInfo/* default */.Z)(goalUID, {
        fallbackData: fallbackData.goalData
    }), goalInfoSWRKey = ref1.key;
    return {
        keys: {
            syllabusSWRKey: syllabusSWRKey,
            goalInfoSWRKey: goalInfoSWRKey
        }
    };
};
/* harmony default export */ var topics_useFullSyllabusInfo = (useFullSyllabusInfo);

;// CONCATENATED MODULE: ./src/pages/goal/[goalSlug]/[goalUID]/topics.jsx























var PlusTopicsPage = function(param) {
    var goalInfo = param.goalInfo, fallbackData = param.fallbackData, isNewSyllabusEnabled = param.isNewSyllabusEnabled, isGTP = param.isGTP, isRecordedGoal = param.isRecordedGoal;
    var query = (0,router.useRouter)().query;
    var ref = goalInfo !== null && goalInfo !== void 0 ? goalInfo : {}, _name = ref.name, name = _name === void 0 ? "Goal" : _name, thumbnail = ref.thumbnail, ogImage = ref.ogImage, goalSlug = ref.slug, goalUID = ref.uid;
    var keys = topics_useFullSyllabusInfo(goalUID, fallbackData, isNewSyllabusEnabled, isRecordedGoal).keys;
    var ref1 = (0,AppCommonData/* usePageSeoContent */.tS)(), title = ref1.title, description = ref1.description;
    var dispatch = (0,es/* useDispatch */.I0)();
    var loadedTopologyFeed = (0,es/* useSelector */.v9)(syllabus/* getIsTopologyFeedLoaded */.wE);
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var metaTitle = title || "Important topics for ".concat(name, " - Unacademy");
    var metaDescription = description || "Explore various courses topic wise to prepare for ".concat(name);
    var canonicalURL = "https://unacademy.com/goal/".concat(goalSlug, "/").concat(goalUID, "/topics");
    (0,react.useEffect)(function() {
        if (!isNewSyllabusEnabled && !loadedTopologyFeed) {
            dispatch((0,topologies/* fetchTopologyFeed */.b1)({
                topologyUid: goalUID,
                pageSource: constants/* PlusTopologySource.TOPICS */.e.TOPICS
            }));
        }
    }, [
        isNewSyllabusEnabled,
        isGTP,
        goalUID,
        dispatch,
        loadedTopologyFeed
    ]);
    (0,sidenav/* useSetSelectedNav */.WF)(plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS);
    if (isGTP && isMobile) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GTPMobileBlocker/* default */.Z, {
            goalInfo: goalInfo || {}
        });
    }
    var renderSyllabusHomePage = function() {
        if (isNewSyllabusEnabled) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomePage_HomePage, {
            source: constants/* PlusTopologySource.TOPICS */.e.TOPICS,
            goalUID: goalUID,
            topicUID: query.topicUid,
            isGTP: isGTP,
            isRecordedGoal: isRecordedGoal,
            topicFilters: fallbackData.topicFilters
        });
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusTopology/* default */.Z, {
            source: constants/* PlusTopologySource.TOPICS */.e.TOPICS,
            goalUID: goalUID,
            topologyUID: goalUID
        });
    };
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* SWRConfig */.J$, {
        value: {
            fallback: (_obj = {}, (0,_define_property/* default */.Z)(_obj, keys.syllabusSWRKey, fallbackData.syllabusData), (0,_define_property/* default */.Z)(_obj, keys.goalInfoSWRKey, fallbackData.goalData), _obj)
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                openGraph: {
                    metaTitle: metaTitle,
                    metaDescription: metaDescription,
                    images: [
                        {
                            url: ogImage || thumbnail
                        }
                    ],
                    url: canonicalURL
                },
                schema: (0,subGoal/* default */.Z)({
                    goal: goalInfo,
                    description: metaDescription,
                    subGoal: {
                        name: "Syllabus",
                        link: "topics"
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: metaTitle
                })
            }),
            renderSyllabusHomePage()
        ]
    });
};
PlusTopicsPage.pageInfo = {
    isMWebSupported: true,
    name: "Syllabus",
    layoutOptions: {
        showPlusNav: true
    }
};
var __N_SSG = true;
/* harmony default export */ var topics = (PlusTopicsPage);
PlusTopicsPage.propTypes = {
    goalInfo: prop_types_default().objectOf((prop_types_default()).unknown).isRequired
};
PlusTopicsPage.Layout = layout/* default */.Z;
PlusTopicsPage.Wrapper = PageReduxProviderWrapper["default"];


/***/ }),

/***/ 62282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E9": function() { return /* binding */ updateGoalLevelOnboardingStatus; },
/* harmony export */   "FJ": function() { return /* binding */ searchTopologyV2; },
/* harmony export */   "Jm": function() { return /* binding */ getPostSubscriptionOnBoardingPreferences; },
/* harmony export */   "KM": function() { return /* binding */ fetchOnboardingGoals; },
/* harmony export */   "YZ": function() { return /* binding */ fetchFreeCoursesOfAConcept; },
/* harmony export */   "Yn": function() { return /* binding */ fetchTopologyInfo; },
/* harmony export */   "b1": function() { return /* binding */ fetchTopologyFeed; },
/* harmony export */   "cN": function() { return /* binding */ fetchTopologyFreeCourseFeed; },
/* harmony export */   "dM": function() { return /* binding */ fetchNewSyllabusFeed; },
/* harmony export */   "nA": function() { return /* binding */ savePreferenceAndFetchNext; },
/* harmony export */   "uJ": function() { return /* binding */ fetchSubscriptionEligibleGoals; },
/* harmony export */   "xC": function() { return /* binding */ fetchTopologyChildrenOfTopic; }
/* harmony export */ });
/* unused harmony exports getGoalLanguages, setGoalLanguage, fetchTopologyChildren, fetchTopologyCourseFeed, fetchTopologyCourses, fetchTopologyExtraInfo, fetchPopularGoalsV2, fetchPreSubscribedStaticContent, fetchAllOnBoardingPreferencesOfAUser, fetchGoalBenefits */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82677);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72894);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38037);








var fetchOnboardingGoals = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_ONBOARDING_GOALS */ .Cs.FETCH_ONBOARDING_GOALS,
        endpoint: "v1/topology/topology-onboarding/?limit=20&scope=paid&include_icons=true&include_platform_goals=true",
        method: "get",
        schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .topologyListsSchema */ .mx,
        directPaginatedEntity: true,
        entityType: "topology"
    };
};
var getGoalLanguages = function(goalUid) {
    return {
        type: topologyTypes.FETCH_GOAL_LANGUAGES,
        endpoint: "v1/uplus/subscription/subscription_goal_languages/?goal_uid=".concat(goalUid),
        method: "get",
        schema: new schema.Array()
    };
};
var setGoalLanguage = function(goalUid, languageCode, languageText) {
    return {
        type: topologyTypes.SET_GOAL_LANGUAGE,
        endpoint: "v1/user/me/plus_language/",
        method: "post",
        data: {
            language: languageCode,
            goal_uid: goalUid
        },
        goalUid: goalUid,
        languageText: languageText,
        schema: new schema.Object({})
    };
};
var fetchTopologyChildren = function(topologyUid) {
    return {
        type: topologyTypes.FETCH_TOPOLOGY_CHILDREN,
        endpoint: "v1/uplus/subscription/topology_children/?topology_uid=".concat(topologyUid),
        method: "get",
        topologyUid: topologyUid,
        schema: new schema.Array({
            topology: topologySchema
        }),
        entityType: "topology"
    };
};
var getTopologyFeed = function(key, resetWithoutEmpty, pageSource) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_TOPOLOGY_FEED */ .Cs.FETCH_TOPOLOGY_FEED,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "feedrow",
            processData: function processData(data) {
                if (pageSource === _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PlusTopologySource.TOPIC_FEED */ .e.TOPIC_FEED) {
                    var ref;
                    var topologyRow = (ref = data.results) === null || ref === void 0 ? void 0 : ref.find(function(feedrow) {
                        return feedrow.type === "topic_group_non_feed" || "topic_group";
                    });
                    if (topologyRow) {
                        topologyRow.topology = topologyRow.data;
                    }
                } else if (pageSource === _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PlusTopologySource.TOPICS */ .e.TOPICS) {
                    var ref1;
                    var topologyRow1 = (ref1 = data.results) === null || ref1 === void 0 ? void 0 : ref1.find(function(feedrow) {
                        return feedrow.type === "topic_groups";
                    });
                    if (topologyRow1) {
                        topologyRow1.extra_block_info.uid = key;
                    }
                }
                return data;
            }
        };
    };
};
var fetchTopologyFeed = function(param) {
    var topologyUid = param.topologyUid, _nextPage = param.nextPage, nextPage = _nextPage === void 0 ? false : _nextPage, pageSource = param.pageSource, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty, _params = param.params, params = _params === void 0 ? {} : _params;
    var queryParams = Object.keys(params).reduce(function(allParams, key) {
        return "".concat(allParams, "&").concat(key, "=").concat(params[key]);
    }, "");
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/uplus/syllabus/feed/?topology_uid=".concat(topologyUid).concat(queryParams, "&limit=5"), getTopologyFeed(topologyUid, resetWithoutEmpty, pageSource), "topologyFeed", topologyUid, resetWithoutEmpty)(nextPage);
};
var fetchNewSyllabusFeed = function(goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_NEW_SYLLABUS_FEED */ .Cs.FETCH_NEW_SYLLABUS_FEED,
        endpoint: "v1/syllabus/home/feed/?goal_uid=".concat(goalUID),
        method: "get",
        goalUID: goalUID
    };
};
var fetchTopologyChildrenOfTopic = function(topologyUid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE */ .Cs.FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE,
        endpoint: "v1/topology/users/".concat(topologyUid, "/children/?limit=50"),
        method: "get",
        topologyUid: topologyUid,
        directPaginatedEntity: true,
        schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .paginatorListSchema */ .EH,
        entityType: "topology"
    };
};
var fetchTopologyInfo = function(topologyUid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_TOPOLOGY_INFO */ .Cs.FETCH_TOPOLOGY_INFO,
        endpoint: "v1/topology/users/".concat(topologyUid, "/self/"),
        method: "get",
        topologyUid: topologyUid === null || topologyUid === void 0 ? void 0 : topologyUid.toUpperCase(),
        schema: new normalizr__WEBPACK_IMPORTED_MODULE_5__/* .schema.Object */ .fK.Object({
            topology: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .topologySchema */ .OY
        }),
        entityType: "topology",
        processData: function processData(data) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
                selfDataFetched: true
            });
        }
    };
};
var getTopologyCourseFeed = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: topologyTypes.FETCH_TOPOLOGY_COURSE_FEED,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "feedrow"
        };
    };
};
var fetchTopologyCourseFeed = function(topologyUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/uplus/subscription/topology_feed/?topology_uid=".concat(topologyUid), getTopologyCourseFeed(topologyUid, resetWithoutEmpty), "topologyCourseFeed", topologyUid, resetWithoutEmpty)(nextPage);
};
var getTopologyCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: topologyTypes.FETCH_TOPOLOGY_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchTopologyCourses = function(key, defaultUrl, nextPage) {
    var resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return paginateAction(defaultUrl, getTopologyCourses(key, resetWithoutEmpty), "topologyCourses", key, resetWithoutEmpty)(nextPage);
};
var fetchTopologyExtraInfo = function(topologyUid) {
    return {
        type: topologyTypes.FETCH_TOPOLOGY_EXTRA_INFO,
        endpoint: "v1/uplus/subscription/feed_block_extra_info/?topology_uid=".concat(topologyUid, "&block_type=topic_group"),
        method: "get",
        topologyUid: topologyUid,
        schema: new schema.Object({})
    };
};
var getTopologyFreeCourseFeed = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_TOPOLOGY_OF_FREE_COURSE_FEED */ .Cs.FETCH_TOPOLOGY_OF_FREE_COURSE_FEED,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "feedrow",
            processData: function(data) {
                var newData = data;
                newData.results = data.results.map(function(resultItem) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, resultItem), {
                        label: resultItem.name,
                        data: resultItem.top_courses,
                        extra_block_info: {
                            id: "course",
                            entity_type: "Course",
                            label: resultItem.name,
                            name: resultItem.name,
                            uid: resultItem.uid
                        },
                        type: "course"
                    });
                });
                return newData;
            }
        };
    };
};
var fetchTopologyFreeCourseFeed = function(topologyUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/topology/users/".concat(topologyUid, "/top_courses/"), getTopologyFreeCourseFeed(topologyUid, resetWithoutEmpty), "topologyFreeCourseFeed", topologyUid, resetWithoutEmpty)(nextPage);
};
var getFreeCoursesOfAConcept = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_FREE_COURSES_OF_A_CONCEPT */ .Cs.FETCH_FREE_COURSES_OF_A_CONCEPT,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchFreeCoursesOfAConcept = function(topologyUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/topology/users/".concat(topologyUid, "/courses/"), getFreeCoursesOfAConcept(topologyUid, resetWithoutEmpty), "freeCoursesOfAConcept", topologyUid, resetWithoutEmpty)(nextPage);
};
var fetchPopularGoalsV2 = function() {
    return {
        type: topologyTypes.FETCH_POPULAR_GOALS_GROUPS,
        endpoint: "v2/topology/popular_goals_groups/",
        method: "get"
    };
};
var searchTopologyV2 = function(topologyLevel, query) {
    var parentLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 30, parentUID = arguments.length > 3 ? arguments[3] : void 0, includeParent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_TOPOLOGIES */ .Cs.FETCH_TOPOLOGIES,
        endpoint: "v1/topology/moderators/search_topology_v2/?level=".concat(topologyLevel, "&q=").concat(query, "&parent_level=").concat(parentLevel, "&parent_uid=").concat(parentUID),
        method: "get",
        schema: new normalizr__WEBPACK_IMPORTED_MODULE_5__/* .schema.Object */ .fK.Object({}),
        processData: function(data) {
            var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data);
            if (includeParent) {
                var results = data.results.map(function(item) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item), {
                        name: "".concat(item.parent.name, " ->  ").concat(item.name)
                    });
                });
                newData.results = results;
            }
            return newData;
        }
    };
};
var fetchPreSubscribedStaticContent = function(goalUID) {
    return {
        type: topologyTypes.FETCH_PRESUBSCRIBED_STATIC_CONTENT,
        endpoint: "api/pre-subscribed-goal-info/".concat(goalUID),
        method: "get",
        hostType: HOST_TYPE.CMS
    };
};
var getPostSubscriptionOnBoardingPreferences = function(goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES */ .Cs.FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES,
        endpoint: "v1/onboarding/start/",
        method: "post",
        data: {
            goal_uid: goalUID
        }
    };
};
var savePreferenceAndFetchNext = function(data, goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.SAVE_PREFERENCE_FETCH_NEXT */ .Cs.SAVE_PREFERENCE_FETCH_NEXT,
        endpoint: "v1/onboarding/preference/",
        method: "post",
        data: data,
        isEditing: !!data.edit_preference,
        goalUID: goalUID,
        key: goalUID
    };
};
var fetchAllOnBoardingPreferencesOfAUser = function(goalUID) {
    return {
        type: topologyTypes.FETCH_ALL_ONBOARDING_PREFERENCE_OF_A_USER,
        endpoint: "v1/onboarding/preferences/?goal_uid=".concat(goalUID),
        method: "get"
    };
};
var updateGoalLevelOnboardingStatus = function(goalUID, status) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.UPDATE_GLO_STATUS */ .Cs.UPDATE_GLO_STATUS,
        goalUID: goalUID,
        status: status
    };
};
var fetchSubscriptionEligibleGoals = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .topologyTypes.FETCH_SUBSCRIPTION_GOALS */ .Cs.FETCH_SUBSCRIPTION_GOALS,
        endpoint: "v1/topology/goal/user_visible/?scope=paid",
        method: "get"
    };
};
var fetchGoalBenefits = function(key) {
    return {
        type: topologyTypes.FETCH_GOAL_BENEFITS,
        endpoint: "api/goal-benefits/".concat(key),
        method: "get",
        hostType: HOST_TYPE.CMS,
        key: key
    };
};


/***/ }),

/***/ 75982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isScheduleDataForDppFetched; },
/* harmony export */   "nB": function() { return /* binding */ getPreviewMode; }
/* harmony export */ });
/* unused harmony exports getSnackBarContent, getSubscriptionFeatures, getSubscriptionHighlights, getIconicFAQs */
var getSnackBarContent = function(param) {
    var others = param.others;
    return others.snackBarContent;
};
var getPreviewMode = function(param) {
    var others = param.others;
    return others.nextPreviewMode || false;
};
var isScheduleDataForDppFetched = function(param) {
    var others = param.others;
    return others === null || others === void 0 ? void 0 : others.isScheduleDataForDppFetched;
};
var getSubscriptionFeatures = function(param) {
    var others = param.others;
    return others.subscriptionFeatures;
};
var getSubscriptionHighlights = function(param) {
    var others = param.others;
    return others.subscriptionHighlights;
};
var getIconicFAQs = function(param) {
    var others = param.others;
    return others.iconicFAQs;
};


/***/ }),

/***/ 83109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ getHasTopologyInfo; },
/* harmony export */   "Cl": function() { return /* binding */ getTopologyCoursesCount; },
/* harmony export */   "NF": function() { return /* binding */ getIsNoTestGoal; },
/* harmony export */   "OQ": function() { return /* binding */ getTopologySlug; },
/* harmony export */   "Qz": function() { return /* binding */ getGoalInfoByUIDFromData; },
/* harmony export */   "dH": function() { return /* binding */ getTopologyOrEmptyObject; },
/* harmony export */   "e1": function() { return /* binding */ getGoalInfoByUID; },
/* harmony export */   "gc": function() { return /* binding */ getTopologyPlusCoursesCount; },
/* harmony export */   "hP": function() { return /* binding */ getTopology; },
/* harmony export */   "qp": function() { return /* binding */ getTopologyDataByUID; },
/* harmony export */   "uc": function() { return /* binding */ getExternalAppsAvailable; },
/* harmony export */   "vo": function() { return /* binding */ getTopologyParentName; },
/* harmony export */   "w6": function() { return /* binding */ getTopologyOnboardingGoals; },
/* harmony export */   "x4": function() { return /* binding */ getTopologyUpcomingCoursesCountThisMonth; },
/* harmony export */   "xm": function() { return /* binding */ getIsSyllabusV1Enabled; },
/* harmony export */   "xr": function() { return /* binding */ getIsTopologySelfDataFetched; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports getTopologiesGoalLanguages, getTopologiesList, getTopologyColor, getOnboardingPreferencesUpdated, getIsCatalogueFeatureAvailable, getIsPlusAvailable, getIsPracticeAvailable, getIsRecordedGoal, getTopologyGoalBenefitsByKey, getPreSubscribedStaticData, getPlatformBenefits, getIsPlatformGoalEnabled, getGoalSynonyms, getHideNudge */
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);

var getTopologies = function(state) {
    return state.topologies;
};
var _goalLanguages;
var getTopologiesGoalLanguages = function(state) {
    return (_goalLanguages = getTopologies(state).goalLanguages) !== null && _goalLanguages !== void 0 ? _goalLanguages : emptyList;
};
var getTopologyDataByUID = function(goalUID) {
    return function(state) {
        return getTopologies(state).data[goalUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
    };
};
var getTopologiesList = function(state) {
    return getTopologies(state).data;
};
var getTopologyInfo = function(state, goalUID) {
    return getTopologies(state).data[goalUID];
};
var getTopologyInfoOrEmptyObject = function(state, goalUID) {
    return getTopologyInfo(state, goalUID) || emptyObject;
};
var getTopologyColor = function(state, goalUID) {
    return getTopologyInfoOrEmptyObject(state, goalUID).colorCode;
};
var getOnboardingPreferencesUpdated = function(goalUID) {
    return function(state) {
        return getTopologies(state).areGoalOnBoardingPreferencesUpdated[goalUID] || false;
    };
};
var getTopology = function(state, uid) {
    return state.topologies.data[uid];
};
var getHasTopologyInfo = function(state, uid) {
    return !!getTopology(state, uid);
};
var getTopologyOrEmptyObject = function(state, uid) {
    return getTopology(state, uid) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyName = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).name || "";
};
var getTopologyCoursesCount = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).coursesCount;
};
var getTopologyUpcomingCoursesCountThisMonth = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).upcomingCoursesThisMonth;
};
var getIsNoTestGoal = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isNoTestGoal;
};
var getIsCatalogueFeatureAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isCatalogueFeatureAvailable || false;
};
var getIsPlusAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isPlusAvailable || false;
};
var getIsPracticeAvailable = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isPracticeAvailable || false;
};
var getIsRecordedGoal = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).isRecordedGoal || false;
};
var getTopologySlug = function(state, uid) {
    var topology = getTopologyOrEmptyObject(state, uid);
    return topology.goalSlug || topology.slug;
};
var getExternalAppsAvailable = function(state, uid) {
    var ref, ref1;
    return ((ref = getTopology(state, uid)) === null || ref === void 0 ? void 0 : ref.externalApps) || ((ref1 = getTopology(state, uid)) === null || ref1 === void 0 ? void 0 : ref1.externalAppsAvailable);
};
var getTopologyPlusCoursesCount = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).plusCourseCount;
};
var getIsTopologySelfDataFetched = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).selfDataFetched;
};
var getTopologyParent = function(state, uid) {
    return getTopologyOrEmptyObject(state, uid).parent || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyParentName = function(state, uid) {
    return getTopologyParent(state, uid).name || "";
};
var _key;
var getTopologyGoalBenefitsByKey = function(key) {
    return function(param) {
        var topologies = param.topologies;
        return (_key = topologies.goalBenefits[key]) !== null && _key !== void 0 ? _key : {};
    };
};
var getGoalInfoByUID = function(param, goalUID) {
    var topologies = param.topologies;
    return topologies.topologyDetails[goalUID];
};
var getPreSubscribedStaticData = function(goalUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies.preSubscribedStaticContent[goalUID];
    };
};
var getGoalInfoByUIDFromData = function(state, goalUID) {
    return state.topologies.data[goalUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
var getTopologyOnboardingGoals = function(param) {
    var topologies = param.topologies;
    return topologies.onboardingGoals;
};
var getPlatformBenefits = function(goalUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies === null || topologies === void 0 ? void 0 : topologies.platformGoalBenefits[goalUID];
    };
};
var getIsSyllabusV1Enabled = function(state, goalUID) {
    return getTopologyOrEmptyObject(state, goalUID).isSyllabusV1Enabled || false;
};
var getIsPlatformGoalEnabled = function(state, goalUID) {
    return getTopologyOrEmptyObject(state, goalUID).isPlatformGoal || false;
};
var getGoalSynonyms = function(param) {
    var topologies = param.topologies;
    return topologies === null || topologies === void 0 ? void 0 : topologies.goalSynonyms;
};
var getHideNudge = function(goalUID) {
    return function(state) {
        var ref;
        return ((ref = getTopologyOrEmptyObject(state, goalUID).goalLevelOnboarding) === null || ref === void 0 ? void 0 : ref.hideNudge) || true;
    };
};


/***/ }),

/***/ 94004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _seo_schemas_subListing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84028);
/* harmony import */ var _schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29630);


var subGoalSchema = function(param) {
    var _goal = param.goal, goal = _goal === void 0 ? {} : _goal, _subGoal = param.subGoal, subGoal = _subGoal === void 0 ? {} : _subGoal, description = param.description;
    var graph = [];
    var subGoalLink = "".concat(goal.permalink, "/").concat(subGoal.link);
    var breads = [
        {
            name: "Home",
            url: "https://unacademy.com"
        },
        {
            name: "Explore",
            url: "https://unacademy.com/explore"
        },
        {
            name: goal.name,
            url: goal.permalink
        },
        {
            name: subGoal.name,
            url: subGoalLink
        }
    ];
    graph.push((0,_schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breads));
    graph.push((0,_seo_schemas_subListing__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        topic: goal.name,
        forPlus: true,
        name: "".concat(goal.name, " ").concat(subGoal.name),
        description: description,
        link: subGoalLink
    }));
    var schema = {
        "@context": "https://schema.org/",
        "@graph": graph
    };
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (subGoalSchema);


/***/ }),

/***/ 51562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actions_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68060);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85690);
/* harmony import */ var _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97296);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28119);
/* harmony import */ var _actions_constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94336);
/* harmony import */ var _utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74392);
/* harmony import */ var _api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79415);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17912);
/* harmony import */ var _captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28029);













var isRefreshing = false;
var subscribers = [];
var fetchErrorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var error, _action, action, dispatch, getState, _rest, rest, options, headers, endpoint, source, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, accessToken, refreshToken, isServer, response, errorResp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    error = param.error, _action = param.action, action = _action === void 0 ? {
                        type: ""
                    } : _action, dispatch = param.dispatch, getState = param.getState, _rest = param.rest, rest = _rest === void 0 ? {} : _rest, options = param.options, headers = param.headers, endpoint = param.endpoint, source = param.source;
                    ;
                    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 400 && (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) < 600) (0,_captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        endpoint: endpoint,
                        error: error,
                        source: source,
                        options: options,
                        headers: headers
                    });
                    if (!((error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401)) {
                        _ctx.next = 35;
                        break;
                    }
                    ref7 = (0,_getTokens__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getState), accessToken = ref7.accessToken, refreshToken = ref7.refreshToken;
                    isServer = "object" === "undefined";
                    if (!(accessToken && refreshToken)) {
                        _ctx.next = 34;
                        break;
                    }
                    if (isRefreshing) {
                        _ctx.next = 32;
                        break;
                    }
                    if (action.type !== "ME") subscribers.push(action);
                    isRefreshing = true;
                    _ctx.prev = 10;
                    _ctx.next = 13;
                    return (0,_api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchNewToken */ .R$)(refreshToken);
                case 13:
                    _ctx.next = 15;
                    return _ctx.sent.json();
                case 15:
                    response = _ctx.sent;
                    if (!(response === null || response === void 0 ? void 0 : response.error)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error(response === null || response === void 0 ? void 0 : response.error);
                case 18:
                    isRefreshing = false;
                    dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .authenticate */ .YR)({
                        accessToken: response.access_token,
                        refreshToken: response.refresh_token
                    }));
                    _ctx.next = 22;
                    return dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyInfo */ .ct)());
                case 22:
                    subscribers.forEach(function(cb) {
                        return dispatch(cb);
                    });
                    _ctx.next = 29;
                    break;
                case 25:
                    _ctx.prev = 25;
                    _ctx.t0 = _ctx["catch"](10);
                    if (!isServer) {
                        (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                            keepSelectedGoal: true
                        });
                        (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                    }
                    dispatch({
                        type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                    });
                case 29:
                    _ctx.prev = 29;
                    subscribers = [];
                    return _ctx.finish(29);
                case 32:
                    _ctx.next = 35;
                    break;
                case 34:
                    {
                        if (!isServer) {
                            (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                                keepSelectedGoal: true
                            });
                            (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                        }
                        dispatch({
                            type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                        });
                    }
                case 35:
                    if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 429) {
                        _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__/* .utils.open */ .P6.open({
                            message: "Too many requests. Please try again after sometime.",
                            type: "error"
                        });
                    }
                    if (!((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) >= 500 || error.status >= 500)) {
                        _ctx.next = 38;
                        break;
                    }
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: error,
                        type: "".concat(action.type, "_FAILURE")
                    })));
                case 38:
                    _ctx.next = 40;
                    return error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.json();
                case 40:
                    errorResp = _ctx.sent;
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: errorResp,
                        type: "".concat(action.type, "_FAILURE"),
                        statusCode: error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.status
                    })));
                case 42:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                10,
                25,
                29,
                32
            ]
        ]);
    }));
    return function fetchErrorHandler(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchErrorHandler);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12828);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(camelcase_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89875);




/**
 * Fetch with response status check.
 * This function must be wrapped in a try/catch block to catch exceptions.
 * Being used in **worker** space as well.
 * @param {string} url
 * @param {object} options
 * @returns {*} any
 */ var fetchWithoutErrorHandling = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
        var ref, headers, _useCamelCase, useCamelCase, _hasTextResponse, hasTextResponse, _requestType, requestType, _isFormData, isFormData, _body, body, fetchOptions, response, resp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = options || {}, headers = ref.headers, _useCamelCase = ref.useCamelCase, useCamelCase = _useCamelCase === void 0 ? false : _useCamelCase, _hasTextResponse = ref.hasTextResponse, hasTextResponse = _hasTextResponse === void 0 ? false : _hasTextResponse, _requestType = ref.requestType, requestType = _requestType === void 0 ? "GET" : _requestType, _isFormData = ref.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _body = ref.body, body = _body === void 0 ? null : _body;
                    fetchOptions = {
                        method: requestType,
                        headers: headers || {},
                        credentials: "same-origin"
                    };
                    if (false) {}
                    if (body) {
                        try {
                            fetchOptions.body = isFormData ? body : JSON.stringify(body);
                        } catch (e) {
                        /* */ }
                    }
                    _ctx.next = 6;
                    return fetch(url, fetchOptions);
                case 6:
                    response = _ctx.sent;
                    (0,_checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(response);
                    if (!(response.status === 204)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 10:
                    ;
                    if (hasTextResponse) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.prev = 12;
                    _ctx.next = 15;
                    return response.json();
                case 15:
                    resp = _ctx.sent;
                    if (useCamelCase) resp = camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default()(resp, {
                        deep: true
                    });
                    _ctx.next = 21;
                    break;
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](12);
                case 21:
                    _ctx.next = 26;
                    break;
                case 23:
                    _ctx.next = 25;
                    return response.text();
                case 25:
                    resp = _ctx.sent;
                case 26:
                    return _ctx.abrupt("return", resp);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                12,
                19
            ]
        ]);
    }));
    return function fetchWithoutErrorHandling(url, options) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchWithoutErrorHandling);


/***/ }),

/***/ 26951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34497);
/* harmony import */ var _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97487);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17912);






var defaultHost = (0,_utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultHost */ .tW)();
var getHeaders = function(param) {
    var url = param.url, getState = param.getState, _headersOptions = param.headersOptions, _useAuthToken = _headersOptions.useAuthToken, useAuthToken = _useAuthToken === void 0 ? true : _useAuthToken, _useSearchToken = _headersOptions.useSearchToken, useSearchToken = _useSearchToken === void 0 ? false : _useSearchToken, _useJWTToken = _headersOptions.useJWTToken, useJWTToken = _useJWTToken === void 0 ? false : _useJWTToken, _isFormData = _headersOptions.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _useStarGateToken = _headersOptions.useStarGateToken, useStarGateToken = _useStarGateToken === void 0 ? false : _useStarGateToken, headers = param.headers;
    var ref = (0,_getTokens__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(getState), accessToken = ref.accessToken, searchToken = ref.searchToken, JWTToken = ref.JWTToken;
    var apiCallHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, useAuthToken && accessToken ? {
        authorization: "Bearer ".concat(accessToken)
    } : "", useJWTToken && JWTToken ? {
        authorization: "Bearer ".concat(JWTToken)
    } : "", useSearchToken && searchToken ? {
        searchToken: "Bearer ".concat(searchToken)
    } : "", !isFormData && {
        "Content-Type": "application/json"
    }, headers || {});
    var isServer = "object" === "undefined";
    if (url.includes(defaultHost)) {
        var platform = !isServer && _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isMobile */ .Z.isMobile({
            isServer: isServer
        }) ? _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.MOBILE */ .iw.MOBILE : _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.OTHER */ .iw.OTHER;
        apiCallHeaders["X-Platform"] = platform;
    }
    if (useStarGateToken) {
        var stargateJWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getStargateJwtToken */ .$1)(getState());
        apiCallHeaders["Stargate-Token"] = stargateJWTToken;
    }
    return apiCallHeaders;
};
/* harmony default export */ __webpack_exports__["Z"] = (getHeaders);


/***/ }),

/***/ 17912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34497);


var getTokens = function(getState) {
    var accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken", getState);
    var refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken", getState);
    if (true) {
        if (!accessToken) accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken");
        if (!refreshToken) refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken");
    }
    var searchToken = typeof getState === "function" ? (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getSearchToken */ .d6)(getState()) : "";
    var JWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getJwtToken */ .rS)(getState());
    return {
        accessToken: accessToken,
        refreshToken: refreshToken,
        searchToken: searchToken,
        JWTToken: JWTToken
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getTokens);


/***/ }),

/***/ 21848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var parseNumber = function(value) {
    var radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return value && parseInt(value, radix) || 0;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,21322,84872,55169,2291,42353,31837,9720,46571,16050,94336,4392,72047,95965,41566,48392,77566,39166,55033,56375,30038,23656,2372,60237,49774,92888,40179], function() { return __webpack_exec__(7967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);